"use strict";

/*
 TODO zoom speed, it is way to fast

 Develop while testing:
 TODO Translations
 TODO color table legend -> unit toggle, lot of work, limited benefit
 TODO test mali GPUs for overflow
 TODO CDN

 Consider:
 TODO speed button for faster animation
 TODO country shape in webgl renderer
 TODO read temp + windspeed and display as number on svg canvas
 TODO reload JSON files in the background
 TODO 'follow the wind'

 Low prio:
 TODO "updated 5 hours ago"
 TODO lake layer, 3rd lod country shapes
 TODO restore context-lost

 Version 2:
 TODO cloud and precipitation layer
 TODO integrated location search
 */

/* perf counter poly. Only used for development to measure time / fps */
/*window.performance = window.performance || {};
performance.now = (function () {
    return performance.now ||
        performance.mozNow ||
        performance.msNow ||
        performance.oNow ||
        performance.webkitNow ||
        function () {
            return new Date().getTime();
        };
})();*/

Array.prototype.equals = function (array) {
    return this.length == array.length &&
        this.every(function (this_i, i) {
            return this_i == array[i]
        })
};

/**
* Send JavaScript error information to Google Analytics.
*
* @param  {Window} window A reference to the "window".
* @return {void}
* @author Philippe Sawicki <https://github.com/philsawicki>
*/
(function (window) {
    // Retain a reference to the previous global error handler, in case it has been set:
    var originalWindowErrorCallback = window.onerror;

    /**
     * Log any script error to Google Analytics.
     *
     * Third-party scripts without CORS will only provide "Script Error." as an error message.
     *
     * @param  {String}           errorMessage Error message.
     * @param  {String}           url          URL where error was raised.
     * @param  {Number}           lineNumber   Line number where error was raised.
     * @param  {Number|undefined} columnNumber Column number for the line where the error occurred.
     * @param  {Object|undefined} errorObject  Error Object.
     * @return {Boolean}                       When the function returns true, this prevents the
     *                                         firing of the default event handler.
     */
    window.onerror = function customErrorHandler (errorMessage, url, lineNumber, columnNumber, errorObject) {
        // Send error details to Google Analytics, if the library is already available:
        if (typeof ga === 'function') {
            // In case the "errorObject" is available, use its data, else fallback
            // on the default "errorMessage" provided:
            var exceptionDescription = errorMessage;
            if (typeof errorObject !== 'undefined' && typeof errorObject.message !== 'undefined') {
                exceptionDescription = errorObject.message;
            }

            // Format the message to log to Analytics (might also use "errorObject.stack" if defined):
            exceptionDescription += ' @ ' + url + ':' + lineNumber + ':' + columnNumber;

            ga('send', 'exception', {
                'exDescription': exceptionDescription,
                'exFatal': false, // Some Error types might be considered as fatal.
                'appName': 'Webgl maps',
                'appVersion': window.maps_options.version
            });
        }

        // If the previous "window.onerror" callback can be called, pass it the data:
        if (typeof originalWindowErrorCallback === 'function') {
            return originalWindowErrorCallback(errorMessage, url, lineNumber, columnNumber, errorObject);
        }
        // Otherwise, Let the default handler run:
        return false;
    };
})(window);


/**
 * Return date format like PHP Date format like "Y-m-d H:i:s"
 *
 * @param format {string}
 * @returns {string}
 */
Date.prototype.toPHPDateFormat = function(format) {
    var temp;
    if(format.indexOf('Y') !== -1) {
        format = format.replace('Y', this.getUTCFullYear().toString());
    }
    if(format.indexOf('n') !== -1) {
        format = format.replace('n', (this.getUTCMonth()+1).toString());
    }
    if(format.indexOf('j') !== -1) {
        format = format.replace('j', this.getUTCDate().toString());
    }
    if(format.indexOf('m') !== -1) {
        temp = this.getUTCMonth() + 1;
        format = format.replace('m', temp < 10 ? '0' + temp : temp.toString());
    }
    if(format.indexOf('d') !== -1) {
        temp = this.getUTCDate();
        format = format.replace('d', temp < 10 ? '0' + temp : temp.toString());
    }
    if(format.indexOf('H') !== -1) {
        temp = this.getUTCHours();
        format = format.replace('H', temp < 10 ? '0' + temp : temp.toString());
    }
    if(format.indexOf('i') !== -1) {
        temp = this.getUTCMinutes();
        format = format.replace('i', temp < 10 ? '0' + temp : temp.toString());
    }
    if(format.indexOf('s') !== -1) {
        temp = this.getUTCSeconds();
        format = format.replace('s', temp < 10 ? '0' + temp : temp.toString());
    }
    if(format.indexOf('l') !== -1) {
        var weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        format = format.replace('l',weekdays[this.getUTCDay()]);
    }

    return format;
};

/**
 * Request webgl context, fetch JSON meta files for all domains, initilise drawControl and start animation
 */
function setupContext() {
    var maps_options = window.maps_options;

    var canvas, svg_canvas, gl;
    /**
     * Request webgl context and load domain init JSON files
     * Once loaded, start initialisation
     */
    canvas = document.getElementById("canvas");
    svg_canvas = document.getElementById('overlay_map');

    function show_error(err) {
        svg_canvas.style.backgroundImage = "url('/website/images/maps/webgl_maps_preview.jpg')";
        var errElement = document.getElementById('errorContainer');
        errElement.className = errElement.className.replace('hide', '');
        console.error(err);
    }

    try {
        var options = {antialias: false, depth: false, alpha: false};
        gl = canvas.getContext('webgl', options);
        if (!gl) {
            gl = canvas.getContext('experimental-webgl', options);
        }
    } catch (e) {
        show_error('webgl context could not be created. Exception was thrown');
        return;
    }
    if (!gl) {
        show_error('webgl context could not be created');
        return;
    }

    // check for required extensions
    var extension = gl.getExtension("OES_texture_half_float");
    var extensionLinear = gl.getExtension("OES_texture_half_float_linear");
    if (!extension || !extensionLinear) {
        extension = gl.getExtension("OES_texture_float");
        extensionLinear = gl.getExtension("OES_texture_float_linear");
    }
    if (!extension || !extensionLinear) {
        show_error("floating point textures are not supported on your system");
        return;
    }

    //show_error("floating point textures are not supported on your system");
    //return;

    var startContainer = document.getElementById('startContainer');
    function loadAndInit() {
        startContainer.className += ' hide';
        svg_canvas.style.backgroundImage = '';

        // Load all domain json files
        var domainInits = [];
        var domains = ['GFS05', 'GFS025', 'NEMS4', 'NEMS12', 'NEMSSA', 'NEMSAF01', 'NEMSIN', 'NEMSAS02', 'NAM12', 'MFFR', 'NAM5', 'NAM2', 'NAMAK', 'NEMSNZ'];
        var domainsLoaded = 0;
        var unixTime = (new Date().getTime()/1000).toFixed(0);
        for(var i = 0; i < domains.length; ++i){
            getJSON('//static.meteoblue.com/pub/flowanimation/' + domains[i] + '.json?' + unixTime, function (data) {
                domainInits[data.order] = data;
                if (++domainsLoaded === domains.length) {
                    var drawControl = new DrawControl(gl, isInIframe, canvas, svg_canvas, domainInits, maps_options);
                    drawControl.start();
                }
            }, function (error) {
                // really should not happen
                console.error('Unable to load model initialisation files', error);
                alert('Unable to load model initialisation files');
            });
        }
    }

    var isInIframe = window.frameElement && window.frameElement.nodeName == "IFRAME";
    if(!maps_options.force_start && isInIframe){
        svg_canvas.style.backgroundImage = "url('/website/images/maps/webgl_maps_preview.jpg')";
        startContainer.className = startContainer.className.replace('hide', '');
        startContainer.addEventListener('click', loadAndInit, false);
    } else {
        loadAndInit();
    }
}
window.onload = setupContext;

/**
 * Helper function to fetch JSON files
 *
 * @param url
 * @param success_callback
 * @param failure_callback
 */
function getJSON(url, success_callback, failure_callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('get', url, true);
    xhr.onload = function () {
        var status = xhr.status;
        if (status == 200) {
            success_callback(JSON.parse(xhr.response));
        } else {
            failure_callback(status);
        }
    };
    xhr.send();
}

/**
 * create a texture and apply linear scaling filter
 *
 * @param gl {WebGLRenderingContext}
 * @returns {WebGLTexture}
 */
function createAndSetupTexture(gl) {
    var texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);

    // Set up texture so we can render any size image and so we are
    // working with pixels.
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);

    return texture;
}
/**
 * Creates a program, attaches shaders, binds attrib locations, links the
 * program and calls useProgram.
 * @param {WebGLShader[]} shaders The shaders to attach
 */
function createProgram(gl, shaders) {
    var program = gl.createProgram();
    shaders.forEach(function (shader) {
        gl.attachShader(program, shader);
    });
    gl.linkProgram(program);

    // Check the link status
    var linked = gl.getProgramParameter(program, gl.LINK_STATUS);
    if (!linked) {
        // something went wrong with the link
        var lastError = gl.getProgramInfoLog(program);
        console.error("Error in program linking:" + lastError);

        gl.deleteProgram(program);
        return null;
    }
    return program;
}

/**
 * Loads a shader from a script tag.
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {string} shaderSource Shader source code
 * @param {number} shaderType The type of shader. If not passed in it will
 *     be derived from the type of the script tag.
 * @return {WebGLShader} The created shader.
 */
function createShaderFromScript(gl, shaderSource, shaderType) {
    // Create the shader object
    var shader = gl.createShader(shaderType);

    // Load the shader source
    gl.shaderSource(shader, shaderSource);

    // Compile the shader
    gl.compileShader(shader);

    // Check the compile status
    var compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    if (!compiled) {
        // Something went wrong during compilation; get the error
        var lastError = gl.getShaderInfoLog(shader);
        console.error("*** Error compiling shader '" + shader + "':" + lastError);
        gl.deleteShader(shader);
        return null;
    }
    return shader;
}



/**
 * Generate Domain program
 *
 * @param gl
 * @param init
 * @param x1
 * @param x2
 * @param y1
 * @param y2
 * @param vertex_offset
 * @param callbackNewDomainData
 * @param time_format
 * @param callbackCenterDomain
 * @constructor
 */
function DomainProgram(gl, init, x1, x2 , y1, y2, vertex_offset, callbackNewDomainData, time_format, callbackCenterDomain) {
    this.x1 = x1;
    this.x2 = x2;
    this.y1 = y1;
    this.y2 = y2;
    this.dt = init.dt;
    this.name = init.domain.toLowerCase();
    this.scale_min = init.min_scale;
    this.callbackCenterDomain = callbackCenterDomain;
    this.dataCallBack = callbackNewDomainData;

    this.vertex_start = vertex_offset * 12;
    this.last_timestep = init.tlast;
    this.tempscales = init.tempscales;
    this.windscales = init.windscales;

    var i, levels = [];
    for (i = 0; i < init.levels.length; ++i) {
        levels.push(init.levels[i] === "sfc" ? 0 : parseInt(init.levels[i]));
    }
    this.levels = levels;

    this.gl = gl;
    this.textures = [];
    this.texture_timestamp = [];
    for (i = 0; i <= 2; ++i) {
        this.textures[i] = createAndSetupTexture(gl);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, 1); // image textures need to be flipped once
    }
    this.loaded = true;
    this.n = false;
    this.slot = 0; // 0=primary, 1=seconday, 2=preload

    var span = document.createElement('div');
    span.classList.add('domain_info');
    var info = document.createElement('div');
    info.classList.add('domain_info_popup');

    var last_updated = (new Date(init.tupdate)).toPHPDateFormat(time_format);
    info.innerHTML = maps_options.translate.last_update+': '+last_updated + '<br/>'+maps_options.translate.source+': '+init.source;
    span.appendChild(document.createTextNode(init.resolution+"km - "+init.domain));
    span.appendChild(info);
    document.getElementById('domainContainer').appendChild(span);

    // disable click on domain -> problematic on mobile
    //span.addEventListener('click', this.eventClickDomainList.bind(this));
    this.span = span;

    /**
     * Create image loader and assign variables and callbacks
     * @type {Image}
     */
    var image = new Image();
    image.addEventListener('load', this.imageOnLoad.bind(this), false);
    image.crossOrigin = "anonymous";
    this.image = image;
}
/**
 * Center Domain to view-port
 *
 * @param e {MouseEvent}
 */
DomainProgram.prototype.eventClickDomainList = function(e) {
    this.callbackCenterDomain(this);
};
/**
 * Image onload function
 */
DomainProgram.prototype.imageOnLoad = function() {
    var gl = this.gl;
    this.loaded = true;
    if (!this.n) { // request was canceled
        return;
    }
    gl.activeTexture(gl.TEXTURE4);
    gl.bindTexture(gl.TEXTURE_2D, this.textures[this.slot]);
    this.texture_timestamp[this.slot] = this.n;
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, this.image);
    this.n = false;
    this.dataCallBack(); // notify draw control
};
/**
 * Updates state counter in case a condition is not met
 *
 * @param animation
 * @param state {DrawControl}
 */
DomainProgram.prototype.prepareDraw = function (animation, state) {
    var texture_timestamp = this.texture_timestamp;
    if (!this.loaded) {
        // still loading stuff
        state.showLoadingMessage = true;

        // pre-load is loading
        if (this.n === animation.preload_timestamp) {
            state.preloaded = false;
            return;
        }

        // primary or secondary are loading
        state.deltaReady = false;
        if (texture_timestamp[0] !== animation.primary_timestamp || animation.fraction > 0) {
            state.drawable = false;
        }
        return;
    }

    // load primary image
    if (texture_timestamp[0] !== animation.primary_timestamp) {
        //console.log('loading primary', this.name, animation.primary_timestamp);
        state.preloaded = false;
        state.deltaReady = false;
        state.drawable = false;
        state.showLoadingMessage = true;
        this.load(animation.primary_timestamp, animation.primary, 0);
        return;
    }

    // load second image if fraction or animation is running
    if (texture_timestamp[1] !== animation.second_timestamp && (state.animation_running || animation.fraction > 0)) {
        state.preloaded = false;
        state.deltaReady = false;
        if (animation.fraction > 0) {
            state.drawable = false;
        }
        if (animation.second_timestamp > this.last_timestep) {
            //console.log('end of domain reached, second image is not loadable', this.name);
            state.endOfDomain = true;
        } else {
            state.showLoadingMessage = true;
            this.load(animation.second_timestamp, animation.second, 1);
        }
        return;
    }

    //  check for pre-load
    if (texture_timestamp[2] !== animation.preload_timestamp && state.animation_running && animation.preload_timestamp <= this.last_timestep) {
        state.showLoadingMessage = true;
        state.preloaded = false;
        this.load(animation.preload_timestamp, animation.preload, 2);
    }
};
/**
 * Calculate whether domain is visible in current viewport based on limit offsets
 * 0 = not visible
 * 1 = visible
 * 2 = full-screen visible
 */
DomainProgram.prototype.isVisible = function (limits_offset, x_ignore, y_ignore, scale, level, translation) {
    if (scale < this.scale_min) {
        return false;
    }
    if (this.levels.indexOf(level) === -1) {
        return false;
    }
    var visible = limits_offset[0] - this.x1 - x_ignore > translation[0] &&
        limits_offset[1] - this.x2 + x_ignore < translation[0] &&
        limits_offset[3] - this.y2 + y_ignore < translation[1] &&
        limits_offset[2] - this.y1 - y_ignore > translation[1];

    // 0.1 is used to mask stupid floating point errors....
    var fullScreen = limits_offset[1] - this.x1 + 0.1 >= translation[0] &&
        limits_offset[0] - this.x2 - 0.1 <= translation[0] &&
        limits_offset[2] - this.y2 - 0.1 <= translation[1] &&
        limits_offset[3] - this.y1 + 0.1 >= translation[1];

    return visible + fullScreen;
};
/**
 * Check if domain has requested time-step or future time-step if checkSecondTimeStep is set
 *
 * @param animation
 * @param {boolean} checkSecondTimeStep
 * @returns {boolean}
 */
DomainProgram.prototype.hasTimeFrame = function (animation, checkSecondTimeStep) {
    var hasSecond = true;
    if (checkSecondTimeStep || animation.fraction > 0) {
        hasSecond = animation.second_timestamp <= this.last_timestep;
    }
    return hasSecond && (animation.primary_timestamp <= this.last_timestep);
};
/**
 * Clear texture cache
 */
DomainProgram.prototype.clearTextureCache = function () {
    this.n = 0;
    this.texture_timestamp = [];
};
/**
 * Swap texture positions
 *
 * @param a from position
 * @param b to position
 */
DomainProgram.prototype.swapTextures = function (a, b) {
    var textures = this.textures;
    var texture_timestamp = this.texture_timestamp;
    var temp = textures[b];
    textures[b] = textures[a];
    textures[a] = temp;
    temp = texture_timestamp[a];
    texture_timestamp[a] = texture_timestamp[b];
    texture_timestamp[b] = temp;
};
/**
 * Enable image textures and draw to frame-buffer
 */
DomainProgram.prototype.draw = function (gl, framebuffer, animation, u_blendimages) {
    var primary = animation.primary_timestamp;
    var second = animation.second_timestamp;
    var fraction = animation.fraction;
    var texture_timestamp = this.texture_timestamp;
    var textures = this.textures;

    if (texture_timestamp[1] === primary) {
        this.swapTextures(0, 1);
    }
    if (texture_timestamp[2] === second) {
        this.swapTextures(1, 2);
    }

    if (texture_timestamp[0] !== primary || (fraction && texture_timestamp[1] !== second)) {
        // unable to draw frame -> no image available
        console.warn('unable to draw ' + fraction + ' in ' + this.name);
        return false;
    }

    // load first image into buffer
    gl.activeTexture(gl.TEXTURE4);
    gl.bindTexture(gl.TEXTURE_2D, textures[0]);

    // load second image into buffer
    gl.activeTexture(gl.TEXTURE5);
    gl.bindTexture(gl.TEXTURE_2D, textures[1]);

    gl.uniform1f(u_blendimages, fraction);
    gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);

    gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, this.vertex_start);
    return true;
};
/**
 * Load data image and assign to slot
 *
 * @param n
 * @param name
 * @param slot
 */
DomainProgram.prototype.load = function (n, name, slot) {
    if (!n) {
        debugger;
    }
    if (n > this.last_timestep) {
        console.warn('invalid load requested ', this.name, ' ', name);
        return; // not available
    }
    var path = '//static.meteoblue.com/pub/flowanimation/' + this.name + "/" + name + ".jpg";
    this.n = n;
    this.slot = slot;
    this.loaded = false;
    this.image.src = ''; // prevent cached images from not fire load events
    this.image.src = path;
    //console.log('loading in slot ' + slot + ' ', name, n, this.name);
};

/**
 * Calculates flow movement from multiple domain programs in canvas coordinates
 *
 * @param {WebGLRenderingContext} gl
 * @constructor
 */
function FlowProgram(gl) {
    this.u_coordinates = null;
    this.u_noisefield = null;
    this.u_noisefield_2 = null;
    this.texture_colortable = null;
    this.program_print_u_mask = null;

    // if the amount of color is changes, fragment shaders need to be updated!
    this.tempcolor = [
        54, 10, 78, 0, // -32°C
        86, 11, 105, 0,
        123, 12, 136, 0,
        163, 12, 168, 0,
        206, 11, 220, 0,
        175, 5, 227, 0,
        137, 4, 225, 0,
        93, 4, 216, 0,
        28, 13, 207, 0,
        27, 52, 215, 0,
        9, 31, 138, 0,
        23, 58, 154, 0, // -10
        32, 84, 136, 0, // -8
        56, 113, 171, 0, // -6
        68, 136, 204, 0, // -4
        90, 173, 255, 0, // -2
        53, 220, 135, 0, // 0°C
        35, 193, 62, 0, // 2
        8, 154, 33, 0, // 4
        7, 130, 28, 0, // 6
        63, 144, 40, 0, // 8
        89, 139, 19, 0, // 10
        130, 144, 15, 0, // 12
        161, 169, 11, 0, // 14
        192, 195, 7, 0, // 16
        223, 220, 3, 0, // 18
        255, 246, 0, 0,
        248, 223, 11, 0,
        253, 202, 12, 0,
        252, 172, 5, 0,
        248, 141, 0, 0,
        255, 102, 0, 0,
        252, 79, 0, 0,
        255, 1, 0, 0,
        243, 26, 0, 0,
        243, 24, 97, 0,
        243, 22, 194, 0,
        212, 15, 140, 0,
        180, 9, 87, 0,
        149, 2, 33, 0 // +46°C
    ];

    this.windcolor = [
        55, 60, 63, 0, // grey
        45, 102, 131, 0, // dark blue
        42, 150, 79, 0, // green
        179, 168, 43, 0, //yellow
        179, 111, 42, 0,// orange
        177, 50, 48, 0, //red
        112, 45, 95, 0 // pink
    ];
    var vertex_shader_plain = "\
        precision highp float;\n\
        \n\
        attribute vec2 a_position;\n\
        attribute vec2 a_texCoord;\n\
        varying vec2 v_texCoord;\n\
        void main() {\n\
            gl_Position = vec4(a_position, 0, 1);\n\
            v_texCoord = a_texCoord;\n\
        }";

    var fragment_shader_noise = "\
        precision highp float;\n\
        \n\
        uniform sampler2D u_coordinates;\n\
        uniform sampler2D u_noisefield;\n\
        uniform vec2 u_canvasSize;\n\
        \n\
        // the texCoords passed in from the vertex shader.\n\
        varying vec2 v_texCoord;\n\
        \n\
        void main() {\n\
            vec4 coords = texture2D(u_coordinates, v_texCoord);\n\
            float speedmask = coords.b;\n\
            float temperature = coords.a;\n\
            vec2 c2 = coords.rg;\n\
            \n\
            float nb       = texture2D(u_noisefield, v_texCoord).a;\n\
            float nc_sharp = texture2D(u_noisefield, v_texCoord + floor(c2) / u_canvasSize).b;\n\
            float random   = fract(sin(dot(c2 * 16.0 + gl_FragCoord.xy,vec2(1.29898+nc_sharp,.78233+nb))) * 3.585453);\n\
            \n\
            // noise update\n\
            float intensity = 0.10 + speedmask / 3.5;\n\
            nc_sharp += step(random, 0.0035) * intensity; // inject\n\
            nc_sharp -= step(0.93, random) * intensity; // remove\n\
            nc_sharp = clamp(nc_sharp, 0.0, 1.0); // limit range\n\
            nb = clamp(nb - 0.015 + nc_sharp, 0.0, 1.0); // limit range\n\
            \n\
            //nb += pow(speedmask, 0.6) * 0.1 * (nc_smooth - nb);\n\
            \n\
            gl_FragColor = vec4(c2, nc_sharp, nb);\n\
            \n\
            //random = step(random, 0.004);\n\
            //gl_FragColor = vec4(c2, nc_sharp, random);\n\
            //gl_FragColor = vec4(random,random,speedmask*4., 1.0);\n\
        }";

    var fragment_shader_copy = "\
        precision highp float;\n\
        \n\
        uniform sampler2D u_noisefield;\n\
        varying vec2 v_texCoord;\n\
        \n\
        void main() {\n\
            gl_FragColor = texture2D(u_noisefield, v_texCoord);\n\
        }";
    var n_tempcolor = this.tempcolor.length / 4;
    var n_windcolor = this.windcolor.length / 4;
    var n_total = n_windcolor + n_tempcolor;
    var temp_scale_factor = ((n_tempcolor-1.0)/n_total).toFixed(5);
    var temp_scale_offset = (0.5/n_total).toFixed(5);
    var wind_scale_factor = ((n_windcolor-1.0)/n_total).toFixed(5);
    var wind_scale_offset = ((n_tempcolor+0.5)/n_total).toFixed(5);

    var fragment_shader_print = "\
        precision highp float;\n\
        \n\
        uniform sampler2D u_noisefield;\n\
        uniform sampler2D u_coordinates;\n\
        uniform sampler2D u_colortable;\n\
        uniform float u_mask;\n\
        \n\
        // the texCoords passed in from the vertex shader.\n\
        varying vec2 v_texCoord;\n\
        \n\
        void main() {\n\
            vec4 coords = texture2D(u_coordinates, v_texCoord);\n\
            float speedmask = coords.b;\n\
            float temperature = coords.a;\n\
            \n\
            //float nc = texture2D(u_noisefield, v_texCoord).b;\n\
            \n\
            vec3 background = mix(0.7 * texture2D(u_colortable, vec2(temperature*"+temp_scale_factor+"+"+temp_scale_offset+", 0.0)).rgb, texture2D(u_colortable, vec2(speedmask*"+wind_scale_factor+" + "+wind_scale_offset+", 0.0)).rgb, u_mask);\n\
            \n\
            float nf = 0.6 * (1.0-pow(1.00-clamp(speedmask,0.0,0.9999),9.5)) * texture2D(u_noisefield, v_texCoord).a;\n\
            \n\
            gl_FragColor = vec4(background + nf * (1.0-background), 1.0); \n\
            \n\
            //gl_FragColor = noisefield;\n\
            //gl_FragColor = vec4(texture2D(u_noisefield, v_texCoord).a,texture2D(u_noisefield, v_texCoord).a,texture2D(u_noisefield, v_texCoord).a,1.0);\n\
            //gl_FragColor = background;\n\
            //gl_FragColor = vec4(nc,nc,nc,1.0);\n\
        }";

    var halfFloat = gl.getExtension("OES_texture_half_float");
    var halfFloatLinearTextures = gl.getExtension("OES_texture_half_float_linear");
    this.framebufferType = null;
    if (halfFloat && halfFloatLinearTextures) {
        this.framebufferType = halfFloat.HALF_FLOAT_OES;
    } else {
        var floatTextures = gl.getExtension("OES_texture_float");
        var floatLinearTextures = gl.getExtension("OES_texture_float_linear");
        if (!floatTextures && !floatLinearTextures) {
            // Texture float extension is check before. This should never happen
            console.error("EEROR: No floating point extension while init flow program");
            return;
        }
        this.framebufferType = gl.FLOAT;
    }

    var vertex_shader = createShaderFromScript(gl, vertex_shader_plain, gl.VERTEX_SHADER);
    var program_noise = createProgram(gl, [vertex_shader, createShaderFromScript(gl, fragment_shader_noise, gl.FRAGMENT_SHADER)]);
    var program_print = createProgram(gl, [vertex_shader, createShaderFromScript(gl, fragment_shader_print, gl.FRAGMENT_SHADER)]);
    var program_copy = createProgram(gl, [vertex_shader, createShaderFromScript(gl, fragment_shader_copy, gl.FRAGMENT_SHADER)]);

    gl.useProgram(program_noise);

    // color table
    this.texture_colortable = createAndSetupTexture(gl);
    gl.activeTexture(gl.TEXTURE3);
    gl.bindTexture(gl.TEXTURE_2D, this.texture_colortable);
    //console.log('color table temp=' + this.tempcolor.length / 4 + ' wind=' + this.windcolor.length / 4);

    var colortable = new Uint8Array(this.tempcolor.concat(this.windcolor));
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, colortable.length / 4, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, colortable);


    /* Initilise programms */
    gl.useProgram(program_noise);
    gl.uniform1i(gl.getUniformLocation(program_noise, "u_coordinates"), 0);
    gl.uniform1i(gl.getUniformLocation(program_noise, "u_noisefield"), 1);

    gl.useProgram(program_print);
    gl.uniform1i(gl.getUniformLocation(program_print, "u_coordinates"), 0);
    gl.uniform1i(gl.getUniformLocation(program_print, "u_noisefield"), 2);
    gl.uniform1i(gl.getUniformLocation(program_print, "u_colortable"), 3);
    this.program_print_u_mask = gl.getUniformLocation(program_print, "u_mask");

    gl.useProgram(program_copy);
    gl.uniform1i(gl.getUniformLocation(program_copy, "u_noisefield"), 2);

    this.program_noise = program_noise;
    this.program_print = program_print;
    this.program_copy = program_copy;

}
/**
 * Create texture and framebuffer
 *
 * @param {WebGLRenderingContext} gl
 * @param width
 * @param height
 * @returns {{framebuffer: WebGLFramebuffer, texture: *}}
 */
FlowProgram.prototype.generateTextureFrameBuffer = function(gl, width, height) {
    var texture = createAndSetupTexture(gl);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, this.framebufferType, null);

    // Create a framebuffer
    var fbo = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, fbo);

    // Attach a texture to it.
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
    return {framebuffer: fbo, texture: texture};
};
/**
 * Setup buffer at given dimensions
 *
 * @param {WebGLRenderingContext} gl
 * @param width
 * @param height
 */
FlowProgram.prototype.initBuffers = function (gl, width, height) {
    gl.useProgram(this.program_noise);
    gl.uniform2f(gl.getUniformLocation(this.program_noise, "u_canvasSize"), width, height);

    // in case of resize -> delete old buffer
    if (this.u_coordinates !== null) {
        gl.deleteTexture(this.u_coordinates.texture);
        gl.deleteTexture(this.u_noisefield.texture);
        gl.deleteTexture(this.u_noisefield_2.texture);
        gl.deleteFramebuffer(this.u_coordinates.framebuffer);
        gl.deleteFramebuffer(this.u_noisefield.framebuffer);
        gl.deleteFramebuffer(this.u_noisefield_2.framebuffer);
    }

    // Textures:
    // 0 = c2 from previous step
    // 1 = noise field from previous step
    // 2 = noise field current step
    // 3 = color table

    gl.activeTexture(gl.TEXTURE0);
    this.u_coordinates = this.generateTextureFrameBuffer(gl, width, height);
    gl.bindTexture(gl.TEXTURE_2D, this.u_coordinates.texture);

    gl.activeTexture(gl.TEXTURE1);
    this.u_noisefield = this.generateTextureFrameBuffer(gl, width, height);
    gl.bindTexture(gl.TEXTURE_2D, this.u_noisefield.texture);

    gl.activeTexture(gl.TEXTURE2);
    this.u_noisefield_2 = this.generateTextureFrameBuffer(gl, width, height);
    gl.bindTexture(gl.TEXTURE_2D, this.u_noisefield_2.texture);

    this.input_buffer = this.u_coordinates.framebuffer;
};
/**
 * Draw flow layer
 * 
 * @param {WebGLRenderingContext} gl
 * @param type_seamless
 */
FlowProgram.prototype.draw = function (gl, type_seamless) {
    gl.activeTexture(gl.TEXTURE2); // no fucking clue why it needs to bind again....
    gl.bindTexture(gl.TEXTURE_2D, this.u_noisefield_2.texture);

    // calculate noise
    gl.useProgram(this.program_noise);
    gl.bindFramebuffer(gl.FRAMEBUFFER, this.u_noisefield_2.framebuffer);
    gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0);

    // print to canvas
    gl.useProgram(this.program_print);
    if(type_seamless !== null) {
        gl.uniform1f(this.program_print_u_mask, type_seamless);
    }
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0);

    // buffer copy
    gl.useProgram(this.program_copy);
    gl.bindFramebuffer(gl.FRAMEBUFFER, this.u_noisefield.framebuffer);
    gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0);
};







/**
 * TimeSlider
 *
 * @constructor
 */
function TimeSlider(timestamp_today, timestamp_tomorrow, labelToday, labelTomorrow, dateFormat) {
    this.labelToday = labelToday;
    this.labelTomorrow = labelTomorrow;
    this.dateFormat = dateFormat;
    this.time = 0;

    var timeSlider = document.getElementById('timeSlider');
    this.hoverProgess = document.getElementById('hoverProgress');
    this.timeHour = document.getElementById('timeHour');
    this.timeHourText = document.createTextNode('');
    this.timeHour.appendChild(this.timeHourText);
    this.timeProgress =  document.getElementById('timeProgress');
    this.hoverHour =  document.getElementById('hoverHour');
    this.hoverHourText = document.createTextNode('');
    this.hoverHour.appendChild(this.hoverHourText);

    this.setTodayTomorrowTime(timestamp_today, timestamp_tomorrow);

    this.eventMoveBind = this.eventMouseMove.bind(this);
    timeSlider.addEventListener('mousemove', this.eventMoveBind, false);
    timeSlider.addEventListener('mouseout', this.eventMouseOut.bind(this), false);
    timeSlider.addEventListener('click', this.eventMouseClick.bind(this), false);
    timeSlider.addEventListener('touchstart', this.eventMoveBind, false);
    timeSlider.addEventListener('touchmove', this.eventMoveBind, false);
    timeSlider.addEventListener('touchend', this.eventTimeBubbleMouseUp.bind(this), false);
    this.timeSlider = timeSlider;
    this.timeSliderBoundingLeft = 0;
    this.timeSliderBoundingRight = 0;

    this.dragOffset = 0.0;

    this.eventTimeBubbleMouseUpBind = this.eventTimeBubbleMouseUp.bind(this);
    this.timeHour.addEventListener('mousedown', this.eventTimeBubbleMouseDown.bind(this), false);

    this.eventResize();
    window.addEventListener('resize', this.eventResize.bind(this), false);
}
/**
 * Set today and tomorrow timestamps. Used to update today and tomorrow marker at date changes
 *
 * @param timestamp_today
 * @param timestamp_tomorrow
 */
TimeSlider.prototype.setTodayTomorrowTime = function(timestamp_today, timestamp_tomorrow) {
    this.timestamp_tomorrow = timestamp_tomorrow;
    this.timestamp_today = timestamp_today;
};

/**
 * On resize adjust bounding box
 */
TimeSlider.prototype.eventResize = function() {
    var box = this.timeSlider.getBoundingClientRect();
    var width_changed = (this.timeSliderBoundingRight - this.timeSliderBoundingLeft) != (box.right - box.left);

    this.timeSliderBoundingLeft = box.left;
    this.timeSliderBoundingRight = box.right;
    if(width_changed) {
        // correct position of time bubble
        var time = this.time;
        this.time = null;
        this.setTime(time);
    }
};

/**
 * Generate time slider for given time range
 *
 * @param start {Number} UTC Start time. Should be at time 00:00
 * @param stop {Number} UTC End time. Should be at time 00:00
 */
TimeSlider.prototype.generateStartStop = function(start, stop) {
    var tr = this.timeSlider;
    var today = this.timestamp_today;
    var tomorrow = this.timestamp_tomorrow;
    var format = this.dateFormat;

    while (tr.firstChild) {
        tr.removeChild(tr.firstChild);
    }

    var fragment = document.createDocumentFragment();
    var i, td, date, label;
    for (i = start; i <= stop; i += 3600000 * 24) {
        date = new Date(i);
        label = today == i ? this.labelToday : (tomorrow == i ? this.labelTomorrow : date.toPHPDateFormat(format));

        td = document.createElement('div');
        td.appendChild(document.createTextNode(label));
        td.className = 'timeElement';
        td.datetime = i;
        fragment.appendChild(td);
    }
    tr.appendChild(fragment);
};

/**
 * Set time slider position
 *
 * @param timestamp {Number} Move time slider to given UTC time
 */
TimeSlider.prototype.setTime = function(timestamp) {
    var children = this.timeSlider.children;
    var length = children.length;
    var child;
    if(this.time == timestamp) {
        return;
    }
    this.time = timestamp;
    // look for first time-step element in slider with give time
    for(var i = 0; i < length; ++i) {
        child = children[i];
        if(child.datetime + 24*3600000 > timestamp) {
            var hour = (timestamp - child.datetime) / 3600000;
            this.timeHourText.textContent = (hour < 10 ? '0' : '') + hour.toFixed(0) + ':00';

            var width = child.getBoundingClientRect().left + hour / 24 * child.offsetWidth - this.timeSliderBoundingLeft;
            this.timeProgress.style.width = width.toFixed(1) + 'px';
            break;
        }
    }
};

/**
 *
 * @param e {MouseEvent}
 */
TimeSlider.prototype.eventTimeBubbleMouseDown = function(e) {
    window.addEventListener('mouseup', this.eventTimeBubbleMouseUpBind, false);
    window.addEventListener('mousemove', this.eventMoveBind, false);

    this.dragOffset = e.layerX - this.timeHour.offsetWidth / 2;
    this.timeHour.classList.add('hide');
    this.hoverProgess.classList.remove('hide');
};

/**
 *
 * @param e {MouseEvent}
 */
TimeSlider.prototype.eventTimeBubbleMouseUp = function(e) {
    window.removeEventListener('mouseup', this.eventTimeBubbleMouseUpBind, false);
    window.removeEventListener('mousemove', this.eventMoveBind, false);
    this.timeProgress.classList.add('notransition');
    this.timeHour.classList.remove('hide');
    this.hoverProgess.classList.add('hide');

    this.eventMouseClick(e);

    var trigger_css_reflow = this.timeProgress.offsetHeight;
    this.timeProgress.classList.remove('notransition');

    this.dragOffset = 0.0;
};


/**
 * User clicked on time slider
 *
 * @param e {MouseEvent}
 */
TimeSlider.prototype.eventMouseClick = function(e) {
    e.preventDefault();
    var hour, datetime;

    // find target from cursor position
    var x = e.changedTouches && e.changedTouches.length > 0 ? e.changedTouches[0].pageX : e.pageX;
    //console.log('click',e,x);
    var width = x - this.dragOffset;
    width = Math.max(this.timeSliderBoundingLeft, Math.min(width, this.timeSliderBoundingRight-1));
    // find date time matching width
    var children = this.timeSlider.children;
    var length = children.length;
    var child;
    for(var i = 0; i < length; ++i) {
        child = children[i];
        if (child.getBoundingClientRect().left + child.offsetWidth > width) {
            hour = Math.floor((width - child.getBoundingClientRect().left) / child.offsetWidth * 24);
            datetime = child.datetime;
            // Set width of progress bar
            this.timeProgress.style.width = (width - this.timeSliderBoundingLeft).toFixed(1) + 'px';

            // update regular time bubble
            this.timeHourText.textContent = (hour < 10 ? '0' : '') + hour.toFixed(0) + ':00';

            // notify draw control about new time-step
            this.time = datetime + hour * 3600000;
            this.timeChangeCallback(datetime + hour * 3600000);

            break;
        }
    }
};

/**
 * User moved cursor out of time slider
 *
 * @param e {MouseEvent}
 */
TimeSlider.prototype.eventMouseOut = function(e) {
    // restore regular time bubble
    this.hoverProgess.classList.add('hide');
    document.getElementById('timeHour').classList.remove('hide');
};

/**
 * User is hovering over time slider
 *
 * @param e {MouseEvent}
 */
TimeSlider.prototype.eventMouseMove = function(e) {
    // hide regular time bubble
    this.timeHour.classList.add('hide');


    // calculate hour and update hover time bubble
    var x = e.touches && e.touches.length > 0 ? e.touches[0].pageX : e.pageX;
    //console.log(e,x);
    var width = x - this.dragOffset;
    var children = this.timeSlider.children;
    var length = children.length;
    var child, hour;
    for(var i = 0; i < length; ++i) {
        child = children[i];
        if(x > this.timeSliderBoundingLeft && child.getBoundingClientRect().left + child.offsetWidth > width) {
            // show hover time bubble and adjust width to mouse cursor
            var hoverProgress = this.hoverProgess;
            hoverProgress.classList.remove('hide');
            hoverProgress.style.width = (x - this.timeSliderBoundingLeft).toFixed(1) + 'px';

            hour = Math.floor((width - child.getBoundingClientRect().left) / child.offsetWidth * 24);
            this.hoverHourText.textContent = (hour < 10 ? '0' : '') + hour + ':00';
            break;
        }
    }
};







/**
 * Draw loop, animation control, counter etc
 */
function DrawControl(gl, isInIframe, canvas, svg_canvas, domainInits, maps_options) {
    this.isInIframe = isInIframe;
    this.isInApp = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Version)/i.test(navigator.userAgent);
    this.anmiationFrameId = null;
    this.scale_min = null;
    this.scale_max = null;
    this.translation = null;
    this.changed_scale = true;
    this.changed_translation = true;
    this.then = 0;
    /* this.framecounter = 0;
    this.time_passed_ms = 0.0;
    this.framecounter_last = 0;
    this.last_fpstime = 0; */
    this.positionMarkerXY = false;
    this.update_domains_in_n_frames = 1;
    this.update_svg_in_n_frames = 1;
    this.nonSteadySpeed = 0.015;
    this.type_string = '';
    this.type_mask = 0;
    this.type_seamless = 0;
    this.level = 0;
    this.canvas_width = 0;
    this.canvas_height = 0;
    this.gl = gl;
    this.canvas = canvas;
    this.svg_canvas = svg_canvas;
    this.domain_program = null;
    this.u_h = null;
    this.u_scale = null;
    this.u_translation = null;
    this.u_blendimages = null;
    this.allDomains = [];
    this.data_start = Date.UTC(2015, 8, 23, 0, 0, 0, 0); // first valid time step in all domains
    this.data_end = 0;
    this.date_format = maps_options.translate.date_format;
    this.time_format = maps_options.translate.time_format;
    this.today = maps_options.translate.today;
    this.tomorrow = maps_options.translate.tomorrow;
    this.lastVisited = {lat: maps_options.lat, lon: maps_options.lon};
    this.currentTouches = {id:[], x:[], y:[]};

    // Enable retina toggle
    this.forceRetina = null;
    this.retinaNode = null;
    if(window.devicePixelRatio >= 2.0) {
        this.retinaNode = document.getElementById('retina');
        this.retinaNode.parentNode.classList.remove('hide');
        if(typeof(Storage) !== "undefined") {
            this.forceRetina = localStorage.getItem("retina");
        }
    }


    this.global_width = 1327;
    this.global_height = 936;

    this.prepareDomainDraw = true;
    this.svg_transform_update = false;

    this.devicePixelRatio = 0.0;

    this.tickBind = this.drawFrame.bind(this);


    /* BEGIN register text nodes */
    /* var fpsElement = document.getElementById("fps");
    this.fpsNode = document.createTextNode("-1");
    fpsElement.appendChild(this.fpsNode); */
    /* END register text nodes */

    /* Menu toggle */
    this.menuNode = document.getElementById('menu');
    this.menuNodeOpen = false;
    var menuToggleNode = document.getElementById('menu_toggle');
    menuToggleNode.addEventListener('click', this.eventClickMenuToggle.bind(this), false);
    menuToggleNode.addEventListener('touchstart', this.eventClickMenuToggle.bind(this), false);

    this.shareNode = document.getElementById('sharer');
    this.sharerNodeOpen = false;
    var shareToggleNode = document.getElementById('sharer-toggle');
    shareToggleNode.addEventListener('click', this.eventClickShareToggle.bind(this), false);
    shareToggleNode.addEventListener('touchstart', this.eventClickShareToggle.bind(this), false);

    /* END Menu toggle */


    document.getElementById("zoom_in").addEventListener("click", this.eventZoomInClick.bind(this));
    document.getElementById("zoom_out").addEventListener("click", this.eventZoomOutClick.bind(this));
    this.currentLocation = document.getElementById("currentLocation");
    this.currentLocation.addEventListener("click", this.eventClickCurrentLocation.bind(this));

    if(!isInIframe) {
        canvas.addEventListener("mousewheel", this.eventMouseWheelChange.bind(this), false); // IE9, Chrome, Safari, Opera
        canvas.addEventListener("DOMMouseScroll", this.eventMouseWheelChange.bind(this), false); // firefox
    } else {
        var fullscreenNode = document.getElementById('fullscreen_button');
        fullscreenNode.addEventListener('click', this.eventClickFullscreen.bind(this), false);
        fullscreenNode.classList.remove('hide');
    }

    // disable social and sharing functionality inside app
    if(this.isInApp) {
        document.getElementById('social').classList.add('hide');
        document.getElementById('logo_container').style.display='none';
    }

    // we set today and tomorrow timestamps later, once we have the timezone from url
    this.timeSlider = new TimeSlider(null, null, maps_options.translate.today, maps_options.translate.tomorrow, maps_options.translate.date_format);
    this.timeSlider.timeChangeCallback = this.eventCallbackTimeSlider.bind(this);

    /* mouse movement stuff */
    this.mouseMoved = false;

    // click and move must not be started for non-canvas elements like sliders, etc
    this.eventMouseMoveBind = this.eventMouseMove.bind(this);
    this.eventMouseUpBind = this.eventMouseUp.bind(this);
    canvas.addEventListener("mousedown", this.eventMouseDown.bind(this), false);
    var forecastLink = document.getElementById('forecastLink');
    forecastLink.hrefBase = forecastLink.href;
    this.forecastLinkText = document.createTextNode('');
    forecastLink.appendChild(this.forecastLinkText);
    this.forecastLink = forecastLink;
    this.doubleTapCounter = 0;
    this.doubleTapTimer = 0;
    canvas.addEventListener("touchstart", this.eventTouchStart.bind(this), false);
    canvas.addEventListener("touchend", this.eventTouchEnd.bind(this), false);
    canvas.addEventListener("touchmove", this.eventTouchMove.bind(this), true);
    /* END mouse movement stuff */

    // zoom to double click
    canvas.addEventListener("dblclick", this.eventMouseDoubleClick.bind(this), false);
    this.resize_in_n_frames = 0;
    window.addEventListener('resize', this.eventWindowResize.bind(this), false);
    window.addEventListener('keydown', this.eventKeyDown.bind(this), false);
    this.playPauseNode = document.getElementById("button_play");
    this.playPauseNode.addEventListener('click', this.eventPlayPauseToggle.bind(this), false);


    this.limits_offset = null;
    this.visibleDomains = [];
    this.visibleDomainsNext = false;
    this.animation_start = 0;
    this.animation_end = 0;
    this.drawable = true;
    this.preloaded = true;
    this.deltaReady = true;
    this.endOfDomain = false;
    this.animation_running = false;
    this.showLoadingMessageNode = document.getElementById('timeProgress');
    this.showLoadingMessage = true;
    this.showLoadingMessageActive = false;
    this.showLoadingMessageInFrames = 1;
    this.dt1 = {
        fraction: 0.0,
        primary_timestamp: false,
        second_timestamp: false,
        preload_timestamp: false,
        primary: false,
        second: false,
        preload: false
    };
    this.dt3 = {
        fraction: 0.0,
        primary_timestamp: false,
        second_timestamp: false,
        preload_timestamp: false,
        primary: false,
        second: false,
        preload: false
    };

    /**
     *  toggle wind temp
     */
    this.typeSelectorNode = document.getElementById('type_selector');
    this.levelNode = document.getElementById('level');
    this.typeSelectorNode.addEventListener('change', this.eventTypeDropDownChange.bind(this), false);

    window.addEventListener('hashchange', this.eventLocationHashChange.bind(this), false);

    /**
     * END url location hash stuff
     */



    document.getElementById('hour_backward').addEventListener('click', this.eventClickHourBackward.bind(this), false);
    document.getElementById('hour_forward').addEventListener('click', this.eventClickHourForward.bind(this), false);
    document.getElementById('day_forward').addEventListener('click', this.eventClickDayForward.bind(this), false);
    document.getElementById('day_backward').addEventListener('click', this.eventClickDayBackward.bind(this), false);


    /* BEGIN seamless zoom */
    this.seamless_itr = 0;
    this.deltaScale = 0;
    this.logScale = 0;
    this.deltaTranslation = [0, 0];
    /* END seamless zoom */

    this.translation = false;
    this.scale_min = 0; // calculcated in setCanvasSizes()
    this.scale_max = 0;
    this.scale = 6;
    this.timezone = '';

    this.utc_offset = null;
    this.now_button = document.getElementById('now_button');
    this.now_button.addEventListener('click', this.eventClickNowTime.bind(this), false);

    this.setCanvasSizes();
    this.flowProgram = new FlowProgram(gl);
    this.flowProgram.initBuffers(gl, this.canvas_width, this.canvas_height);

    this.initDomains(domainInits);

    // load capitals
    this.capitals = [];
    this.loadLocationList(maps_options.lang);


    this.eventLocationHashChange(); // get stuff from url

    if(!this.timezone) {
        this.setTimezone(maps_options.timezone);
    }

    // Set location marker to last visited location
    var geo_posx = this.lon2posx(maps_options.lon);
    var geo_posy = this.lat2posy(maps_options.lat);

    // center viewport for geo IP feature
    if(!this.translation) {
        this.translation = [
            this.canvas_width / 2.0 - geo_posx,
            this.canvas_height / 2.0 - geo_posy
        ];
        this.scale = Math.max(this.scale_min, Math.min(maps_options.scale * this.devicePixelRatio, this.scale_max));
    }

    // show geoip marker
    if (this.isInApp) {
        // do not use geo IP for app.. use lat/lon provided by url hash
        geo_posx = this.canvas_width / 2.0 - this.translation[0];
        geo_posy = this.canvas_height / 2.0 - this.translation[1];
    }
    this.geoMarkerXY = [geo_posx, geo_posy, maps_options.location];

    // if hash change did not set default values
    if (!this.animation_start) {
        this.initAnimationTimeframe(); // today to 6-days
        this.playPauseNode.children[0].className = this.animation_running ? 'glyph pause' : 'glyph play';

        this.timeSlider.generateStartStop(this.animation_start, this.animation_end);
        this.setTimeStep(this.timestamp_now);
        this.setNewLevelType(0, 'wind', true); // surface
    }

    this.type_mask = this.type_string == 'wind';
    this.type_seamless = this.type_mask * 0.999; // fix for initial upload

    // start loading svg background
    this.svg_image_low = null;
    this.svg_image_high = null;
    this.svg_context = this.svg_canvas.getContext('2d');
    this.svg_context.translation = [this.translation[0], this.translation[1]];
    this.svg_context.scale = this.scale;

    var image_low = new Image();
    this.svg_image_low = image_low;
    image_low.addEventListener('load', this.svgOnLoad.bind(this), false );
    image_low.loaded = false;
    image_low.src = "/webLEA/countries_medium.svg";
    var image_high = new Image();
    this.svg_image_high = image_high;
    image_high.addEventListener('load', this.svgOnLoad.bind(this), false );
    image_high.loaded = false;
    image_high.src = "/webLEA/countries_high.svg";

    //console.log('animation start', new Date(this.animation_start));
    //console.log('animation end', new Date(this.animation_end));
}
/**
 * Generate current timestamps
 */
DrawControl.prototype.initTimestamps = function() {
    var timestamp_now = new Date();
    timestamp_now.setUTCMilliseconds(0);
    timestamp_now.setUTCMinutes(0);
    timestamp_now.setUTCSeconds(0);
    timestamp_now = timestamp_now.getTime();
    this.timestamp_now = timestamp_now;

    // get today UTC timestamp... add utc_offset for correct local today
    var timestamp_today = new Date(timestamp_now - this.utc_offset);
    timestamp_today.setUTCHours(0);
    timestamp_today.setUTCMinutes(0);
    timestamp_today.setUTCSeconds(0);
    timestamp_today.setUTCMilliseconds(0);
    timestamp_today = timestamp_today.getTime();
    this.timestamp_tomorrow = timestamp_today + 3600000 * 24;
    this.timestamp_today = timestamp_today;

    // update time slider
    this.timeSlider.setTodayTomorrowTime(this.timestamp_today, this.timestamp_tomorrow);
};
/**
 * Start loading of localized locations
 *
 * @param lang {String}
 */
DrawControl.prototype.loadLocationList = function(lang) {
    getJSON('/webLEA/location_labels/important_locations_'+lang+'_v2.json', function (data) {
        var i, o, len = data.length;
        for(i = 0; i < len; ++i) {
            o = data[i];
            o.x = this.lon2posx(o.lon);
            o.y = this.lat2posy(o.lat);
        }
        this.capitals = data;
        this.update_svg_in_n_frames = 1; // update svg map
    }.bind(this), function (status) {
        console.warn('Could not load location list', status);
    }.bind(this));
};
/**
 * Set new timezone if applicable
 *
 * @param timezone {String}
 * @returns {boolean}
 */
DrawControl.prototype.setTimezone = function(timezone) {
    if(this.timezone == timezone) {
        return false;
    }
    var pos = timezone.indexOf('+');
    var pos2 = timezone.indexOf(':', pos);
    if(pos === -1) {
        pos = timezone.indexOf('-');
    }
    if(pos === -1 || pos2 === -2 || pos > 6) {
        throw 'Invalid timezone';
    }
    this.utc_offset = parseInt(timezone.substr(pos, pos2-pos)) * -3600000;
    this.timezone = timezone;
    document.getElementById('timezone').textContent = timezone.substr(0,pos).replace(/[^A-Za-z]/gi, '');

    // Set current in UTC, today and tomorrow timestamps
    this.initTimestamps();

    return true;
};
/**
 * Update canvas width and height by current window.innerHeight/Width
 *
 * Called on init and resise events
 */
DrawControl.prototype.setCanvasSizes = function() {
    var width = window.innerWidth;
    var height = window.innerHeight;
    var devicePixelRatio = window.devicePixelRatio || 1.0;

    if(devicePixelRatio > 1.0) {
        devicePixelRatio = 2.0;
    }
    // Disable retina on request
    if(this.forceRetina === 'disable') {
        devicePixelRatio = 1.0;
    }
    if(this.retinaNode) {
        this.retinaNode.checked = devicePixelRatio > 1.0;
    }
    var widthHigh = Math.floor(width * devicePixelRatio);
    var heightHigh = Math.floor(height * devicePixelRatio);

    // 4k is currently the maximum webgl supports
    if(widthHigh > 4096) {
        console.warn('Resolution is limited to 4k!');
        widthHigh = 4096;
        devicePixelRatio = widthHigh / width;
        heightHigh = Math.floor(height * devicePixelRatio);
    }
    if(heightHigh > 4096) {
        console.warn('Resolution is limited to 4k!');
        heightHigh = 4096;
        devicePixelRatio = heightHigh / height;
        widthHigh = Math.floor(width * devicePixelRatio);
    }

    // keep center point fixed
    if(this.translation) {
        this.translation[0] += (widthHigh - this.canvas_width) / 2.0;
        this.translation[1] += (heightHigh - this.canvas_height) / 2.0;
        this.scale *= devicePixelRatio / this.devicePixelRatio;
    }

    var canvas = this.canvas;
    canvas.width = widthHigh;
    canvas.height = heightHigh;
    canvas.style.height = height + "px";
    if (/iPad|iPhone|iPod/.test(navigator.platform)) {
        // All other reflow methods seem to fail. This is the only one, that seems to work
        canvas.style.width = (width-1) + "px";
        window.setTimeout(function() { canvas.style.width = width + "px"; },1);
    } else {
        canvas.style.width = width + "px";
    }

    var svg_canvas = this.svg_canvas;
    svg_canvas.width = widthHigh;
    svg_canvas.height = heightHigh;
    svg_canvas.style.width = width + "px";
    svg_canvas.style.height = height + "px";

    // update min and max scales
    this.scale_min = Math.max(Math.abs(widthHigh / this.global_width), Math.abs(heightHigh / this.global_height));
    this.scale_max = 100 * devicePixelRatio;
    this.scale = Math.max(this.scale_min, Math.min(this.scale, this.scale_max));

    this.canvas_width = widthHigh;
    this.canvas_height = heightHigh;
    this.devicePixelRatio = devicePixelRatio;
    this.gl.viewport(0, 0, widthHigh, heightHigh);
};
/**
 * Callback function for new data arrival. Called from domain programs
 *
 * Schedule domain check for next animation frame
 */
DrawControl.prototype.callbackNewDomainData = function() {
    this.prepareDomainDraw = true;
};
/**
 * Get y-position in global scope for given latitude
 *
 * Applies correciton values for gfs025 scaling:
 * 179.643 as max longitude
 * 0.1174 latitude offset
 *
 * @param lat {number}
 * @returns {number}
 */
DrawControl.prototype.lat2posy = function(lat) {
    // lat offsets -77.5482 77.4308
    // lon offsets -179.643 179.643
    var pi = Math.PI;
    var mercN = Math.log(Math.tan((pi / 4) - ((lat + 0.1174) * pi / 360)));
    return (this.global_height / 2) - (this.global_width * (180 / 179.643) * mercN / (2 * pi));
};
/**
 * Get x-position in global scope for given longitude
 * @param lon {number}
 * @returns {number}
 */
DrawControl.prototype.lon2posx = function(lon) {
    var lon_corrected = lon * (180 / 179.643);
    return (lon_corrected + 180) * (this.global_width) / 360;
};
/**
 * Get longitude for given x-position in global scope
 * @param x {number}
 * @returns {number}
 */
DrawControl.prototype.posx2lon = function(x) {
    return (x * 360 / this.global_width - 180) * (179.643 / 180);
};
/**
 * Get latitude for given y-position in global scope
 * @param y {number}
 * @returns {number}
 */
DrawControl.prototype.posy2lat = function(y) {
    var pi = Math.PI;
    var mercN = (-y + (this.global_height / 2)) * (2 * pi) / (this.global_width * (180 / 179.643));
    return ((pi / 2) - Math.atan(Math.exp(mercN)) * 2) * 180 / pi - 0.1174;
};
/**
 * Click on zoom-in button
 * @param e {Event}
 */
DrawControl.prototype.eventZoomInClick = function (e) {
    e.preventDefault();
    this.seamlessZoom(2.0 * this.scale, this.translation.slice())
};
/**
 * Click on zoom-out button
 * @param e {Event}
 */
DrawControl.prototype.eventZoomOutClick = function (e) {
    e.preventDefault();
    this.seamlessZoom(this.scale / 2.0, this.translation.slice());
};
/**
 * Seamless zoom to coordinates
 *
 * @param scale {number}
 * @param lat {number}
 * @param lon {number}
 */
DrawControl.prototype.seamlessZoomCoordinates = function(scale, lat, lon) {
    var posx = this.lon2posx(lon);
    var posy = this.lat2posy(lat);
    this.positionMarkerXY = [posx, posy];
    this.seamlessZoom(scale, [
        this.canvas_width / 2.0 - posx,
        this.canvas_height / 2.0 - posy
    ]);
};
/**
 * Click on current location -> use gps position
 * @param e {MouseEvent}
 */
DrawControl.prototype.eventClickCurrentLocation = function (e) {
    e.preventDefault();
    this.currentLocation.classList.add('loading');
    navigator.geolocation.getCurrentPosition(function(position) {
        this.currentLocation.classList.remove('loading');
        this.seamlessZoomCoordinates(20, position.coords.latitude, position.coords.longitude);
    }.bind(this), function(error) {
        this.currentLocation.classList.remove('loading');
        this.seamlessZoomCoordinates(Math.max(40 * this.devicePixelRatio, this.scale), this.lastVisited.lat, this.lastVisited.lon);
    }.bind(this));
};
/**
 * Handle Mouse wheel change
 * Zoom in and keep current position steady on mouse cursor position
 * @param e {WheelEvent}
 */
DrawControl.prototype.eventMouseWheelChange = function (e) {
    e.preventDefault();
    //console.log(e.wheelDelta, e);
    var y;
    if('detail' in e) {y = e.detail / 4; }
    if('wheelDelta' in e) {y = e.wheelDelta / 120; }
    if('wheelDeltaY' in e) {y = e.wheelDeltaY / 120; }
    if('deltaY' in e) {
        y = e.deltaY / 40;
        if(e.deltaMode == 1) { y *= 40; } // delta in line units
        if(e.deltaMode == 2) { y *= 800; } // delta in page units
    }
    y /= -4; // reduce speed and invert

    var new_scale = (y + 1) * this.scale;
    new_scale = Math.min(this.scale_max, Math.max(new_scale, this.scale_min));
    if (new_scale == this.scale) {
        return;
    }
    this.scale = new_scale;
    this.translation[0] -= (((e.clientX * this.devicePixelRatio - this.canvas_width / 2) * y) / new_scale);
    this.translation[1] -= (((this.canvas_height / 2 - e.clientY * this.devicePixelRatio) * y) / new_scale);

    this.changed_scale = true;
    this.changed_translation = true;
};
/**
 * Mouse was clicked -> Start dragging
 * @param e {MouseEvent}
 */
DrawControl.prototype.eventMouseDown = function (e) {
    window.addEventListener("mouseup", this.eventMouseUpBind, false);
    window.addEventListener("mousemove", this.eventMouseMoveBind, false);
    this.mouseMoved = false;
    e.touches = [{clientX: e.clientX, clientY: e.clientY}];
    this.eventTouchStart(e);
};
/**
 * Handle mouse move -> Delegate to touch move event
 * @param e {MouseEvent}
 */
DrawControl.prototype.eventMouseMove = function(e) {
    this.mouseMoved = true;
    e.touches = [{clientX: e.clientX, clientY: e.clientY}];
    this.eventTouchMove(e);
};
/**
 * Mouse was released
 * In case user did not move -> assume "single-click" and create a marker at given position
 * TODO Translation
 * @param e {MouseEvent}
 */
DrawControl.prototype.eventMouseUp = function (e) {
    window.removeEventListener("mouseup", this.eventMouseUpBind, false);
    window.removeEventListener("mousemove", this.eventMouseMoveBind, false);
    if (!this.mouseMoved && !this.isInIframe && !this.isInApp) {
        var posx = -this.translation[0] + this.canvas_width / 2 + (e.clientX * this.devicePixelRatio - this.canvas_width / 2) / this.scale;
        var posy = -this.translation[1] + this.canvas_height / 2 - (e.clientY * this.devicePixelRatio - this.canvas_height / 2) / this.scale;
        this.positionMarkerXY = [posx, posy];
        var lon = this.posx2lon(posx);
        var lat = this.posy2lat(posy);
        this.update_svg_in_n_frames = 1;

        var link = this.forecastLink;
        link.classList.remove('hide');
        this.forecastLinkText.nodeValue =  lat.toFixed(1) + '°N ' + lon.toFixed(1) + '°E';
        link.href = link.hrefBase + '?lat=' + lat.toFixed(4) + '&lon=' + lon.toFixed(4);

        if(this.timerHideClickToForecast) {
            clearTimeout(this.timerHideClickToForecast);
        }
        this.timerHideClickToForecast = setTimeout(function() {
            link.classList.add('hide');
            this.positionMarkerXY = false;
            this.update_svg_in_n_frames = 1;
        }.bind(this), 5000);

        //console.log('clicked on', [lat, lon]);
    }
};
/**
 * User double clicked on canvas -> start seamless zoom and center to new position
 * Alternatively we could keep mouse cursor position steady
 * @param e {MouseEvent}
 */
DrawControl.prototype.eventMouseDoubleClick = function (e) {
    // set clicked position to center
    this.seamlessZoom(this.scale * 2.0, [
        this.translation[0] - (e.clientX * this.devicePixelRatio - this.canvas_width / 2) / this.scale,
        this.translation[1] - (this.canvas_height / 2 - e.clientY * this.devicePixelRatio) / this.scale
    ]);
};
/**
 * Handle keyboard inputs
 * Arrow keys left-right control time-steps
 * Arrow keys up-down change level
 * @param e {KeyboardEvent}
 */
DrawControl.prototype.eventKeyDown = function (e) {
    var k = e ? e.which : window.event.keyCode;
    if (e.keyCode === 27 && this.positionMarkerXY) {
        // escape press -> clear marker
        e.preventDefault();
        this.positionMarkerXY = null;
        this.update_svg_in_n_frames = 1;
        this.forecastLink.classList.add('hide')
    }
    if (k === 37 || k === 39) {
        // left right arrow -> next previous timesteap
        e.preventDefault();
        this.animation_running = false; // stop animation
        this.playPauseNode.children[0].className = this.animation_running ? 'glyph pause' : 'glyph play';
        this.setTimeStep(this.dt1.primary_timestamp + 3600000 * (k === 37 ? -1 : 1));
        this.updateVisibleDomainList(); // new timestep might be outside domain timeframe
        this.prepareDrawAll();
    }
    if (k === 38 || k === 40) {
        // up down arrow -> level up or down
        e.preventDefault();
        var gfs05 = this.allDomains[0]; // gfs05 has all levels
        var newPos = gfs05.levels.indexOf(this.level) + (k === 38 ? 1 : -1);
        if (newPos >= 0 && newPos < gfs05.levels.length) {
            this.setNewLevelType(gfs05.levels[newPos], this.type_string, true);
        }
    }
};
/**
 * Browser was re-size. Schedule update of canvas size in 60 frames
 * @param e {Event}
 */
DrawControl.prototype.eventWindowResize = function (e) {
    this.resize_in_n_frames = 60;
};
/**
 * Click on pause/start
 * @param e {MouseEvent}
 */
DrawControl.prototype.eventPlayPauseToggle = function (e) {
    e.preventDefault();
    this.animation_running = !this.animation_running;
    //console.log('new animation running state:', this.animation_running);
    this.playPauseNode.children[0].className = this.animation_running ? 'glyph pause' : 'glyph play';
    if (this.animation_running) {
        this.prepareDrawAll();
    }
};
/**
 * User starts touching the screen
 * @param e {TouchEvent}
 */
DrawControl.prototype.eventTouchStart = function (e) {
    // close menu
    if(this.menuNodeOpen) {
        this.menuNode.classList.add('hide');
        this.menuNodeOpen = false;
    }
    // close sharer menu
    if(this.sharerNodeOpen) {
        this.shareNode.classList.add('hide');
        this.sharerNodeOpen = false;
    }

    var touch;
    var currentTouches = {id:[], x:[], y:[]};
    for(var i = 0; i< e.touches.length; i++) {
        touch = e.touches[i];
        currentTouches.id.push(touch.identifier?touch.identifier:0);
        currentTouches.x.push(touch.clientX);
        currentTouches.y.push(touch.clientY);
    }
    this.currentTouches = currentTouches;

    // register double tap (300ms between touches)
    if(e.touches.length === 1 && Date.now() - this.doubleTapTimer < 300) {
        this.doubleTapCounter++;
    } else {
        this.doubleTapCounter = 0;
    }
    this.doubleTapTimer = Date.now();


    e.preventDefault();
};
/**
 * Stop touching
 * Check for double taps and start seamless zoom
 * @param e {TouchEvent}
 */
DrawControl.prototype.eventTouchEnd = function (e) {
    // 150ms max touch duration
    if(e.changedTouches.length === 1 && Date.now() - this.doubleTapTimer < 150) {
        this.doubleTapTimer = Date.now();
        this.doubleTapCounter++;
        if(this.doubleTapCounter >= 3) {
            this.seamlessZoom(this.scale * 2.0, [
                this.translation[0] - (e.changedTouches[0].clientX * this.devicePixelRatio - this.canvas_width / 2) / this.scale,
                this.translation[1] - (this.canvas_height / 2 - e.changedTouches[0].clientY * this.devicePixelRatio) / this.scale
            ]);
            this.doubleTapCounter = 0;
        }
    } else {
        this.doubleTapCounter = 0;
    }
};
/**
 * Touch move
 * @param e {TouchEvent}
 */
DrawControl.prototype.eventTouchMove = function(e) {
    e.preventDefault();
    var index, touch, i;
    var currentTouches = this.currentTouches;

    // pinch to zoom, calculate difference in distance from 2 touch events
    if(e.touches.length === 2){
        var index1 = currentTouches.id.indexOf(e.touches[0].identifier);
        var index2 = currentTouches.id.indexOf(e.touches[1].identifier);
        var dx = currentTouches.x[index1] - currentTouches.x[index2];
        var dy = currentTouches.y[index1] - currentTouches.y[index2];
        var distOld = Math.sqrt(dx*dx + dy*dy);

        dx = e.touches[0].clientX - e.touches[1].clientX;
        dy = e.touches[0].clientY - e.touches[1].clientY;
        var distNew = Math.sqrt(dx*dx + dy*dy);

        var delta_scale = (distNew - distOld) / 150;
        var new_scale = this.scale + delta_scale * this.scale;
        new_scale = Math.min(this.scale_max, Math.max(new_scale, this.scale_min));
        if (new_scale != this.scale) {
            this.scale = new_scale;

            // keep center point of 2 touch points in the middle while zooming
            var center_x = (e.touches[0].clientX + e.touches[1].clientX)/2;
            var center_y = (e.touches[0].clientY + e.touches[1].clientY)/2;
            this.translation[0] -= (((center_x * this.devicePixelRatio - this.canvas_width / 2) * delta_scale) / new_scale);
            this.translation[1] -= (((this.canvas_height / 2 - center_y * this.devicePixelRatio) * delta_scale) / new_scale);

            this.changed_translation = true;
            this.changed_scale = true;
        }
    }

    // calculate pointer movement from all inputs
    for(i = 0; i < e.touches.length; i++) {
        touch = e.touches[i];
        index = currentTouches.id.indexOf(touch.identifier?touch.identifier:0);

        this.translation[0] += (touch.clientX - currentTouches.x[index]) / this.scale * this.devicePixelRatio / e.touches.length;
        this.translation[1] -= (touch.clientY - currentTouches.y[index]) / this.scale * this.devicePixelRatio / e.touches.length;
        this.changed_translation = true;

        currentTouches.x[index] = touch.clientX;
        currentTouches.y[index] = touch.clientY;
    }
};
/**
 * Type (wind, temperature) or level was changed
 * @param e {Event}
 */
DrawControl.prototype.eventTypeDropDownChange = function(e) {
    // Enable or disable retina
    if(e.target.id == 'retina') {
        this.forceRetina = e.target.checked?'enable':'disable';
        this.resize_in_n_frames = 1;
        if(typeof(Storage) !== "undefined") {
            localStorage.setItem('retina', this.forceRetina);
        }
        e.preventDefault();
        return;
    }

    // Switch type / layer
    var newType;
    var form = e.currentTarget;
    for (var i = 0; i < form.type.length; i++) {
        if (form.type[i].checked) {
            newType = form.type[i].id;
        }
    }
    this.setNewLevelType(parseInt(this.levelNode.value), newType, false);
    this.updateLocationHash();
};
/**
 * Update translation according to new limit_offsets
 * Translation vetor must not exceed global domain
 *
 * @param translation
 * @param limits_offset
 */
DrawControl.prototype.adjustBoundaries = function(translation, limits_offset) {
    translation[0] = Math.max(limits_offset[0] - this.global_width, Math.min(translation[0], limits_offset[1]));
    translation[1] = Math.max(limits_offset[2] - this.global_height, Math.min(translation[1], limits_offset[3]));
};
/**
 * Calculates limit_offsets for given scale and current window canvas size
 *
 * @param scale
 * @returns {*[]}
 */
DrawControl.prototype.calculateLimits = function(scale) {
    var width = this.canvas_width;
    var height = this.canvas_height;
    return [
        ((scale + 1) * width) / (2 * scale),
        ((scale - 1) * width) / (2 * scale),
        ((scale + 1) * height) / (2 * scale),
        ((scale - 1) * height) / (2 * scale)
    ];
};

/**
 * Set new pressure level
 * Generate new filenames, reset caches and find domains supporting this level
 */
DrawControl.prototype.setNewLevelType = function(newLevel, newType, updateHtmlNode) {
    var i;
    if (this.level === newLevel && this.type_string === newType) {
        return;
    }

    if (newLevel !== this.level) {
        var gfs05 = this.allDomains[0];
        if(isNaN(newLevel) || gfs05.levels.indexOf(newLevel) === -1) {
            newLevel = gfs05.levels[0];
        }

        //console.log('setting new level', newLevel);
        this.level = newLevel;

        // generate new file-names in dt1+3
        var time = this.dt1.primary_timestamp;
        this.dt1.primary_timestamp = this.dt1.second_timestamp = this.dt1.preload_timestamp = 0;
        this.dt3.primary_timestamp = this.dt3.second_timestamp = this.dt3.preload_timestamp = 0;
        this.dt1.fraction = this.dt3.fraction = 0.0;
        this.setPrimary(this.dt1, 1, time);
        this.setPrimary(this.dt3, 3, time);

        // purge texture-cache in domains
        for (i = 0; i < this.allDomains.length; ++i) {
            this.allDomains[i].clearTextureCache();
        }

        // domain check if level available
        this.visibleDomains = [];
        this.visibleDomainsNext = false;
        this.update_domains_in_n_frames = 1;

        if (updateHtmlNode) {
            this.levelNode.value = newLevel;
        }
    }

    if (newType !== this.type_string) {
        if(newType !== 'wind' && newType !== 'temperature') {
            newType = 'wind';
        }
        //console.log('setting new type', newType);
        this.type_string = newType;
        this.type_mask = newType === 'wind';

        if (updateHtmlNode) {
            for (i = 0; i < this.typeSelectorNode.type.length; i++) {
                this.typeSelectorNode.type[i].checked = this.type_string == this.typeSelectorNode.type[i].id;
            }
        }
    }
    this.generateColorTable();
};
/**
 * Create HTML color table
 */
DrawControl.prototype.generateColorTable = function() {
    var gfs05 = this.allDomains[0]; // gfs05 has all levels
    var tableNode = document.getElementById('colortable');
    while (tableNode.firstChild) {
        tableNode.removeChild(tableNode.firstChild);
    }
    var tr,td, i;
    var sqrt2 = Math.sqrt(2);

    var valueScaling, colorTable, minValue, maxValue, unitName, scaleStart, scaleEnd, reverse;
    if (this.type_string == 'wind') {
        valueScaling = gfs05.windscales[gfs05.levels.indexOf(this.level)];
        colorTable = this.flowProgram.windcolor;
        minValue = 0;
        maxValue = valueScaling[1] / sqrt2 * 0.992; // 100kmh on surface, otherwise it would be 101
        unitName = 'km/h';
        scaleStart = 0;
        scaleEnd = valueScaling[1] / sqrt2;
        reverse = false;

    } else {
        valueScaling = gfs05.tempscales[gfs05.levels.indexOf(this.level)];
        colorTable = this.flowProgram.tempcolor;
        minValue = Math.round(valueScaling[0] * 0.63); // -20°C on surface
        maxValue = Math.round(valueScaling[1] * 0.74); // 34 °C on surface
        unitName = '°C';
        scaleStart = valueScaling[0];
        scaleEnd = valueScaling[1];
        reverse = true;
    }
    td = document.createElement('td');
    td.appendChild(document.createTextNode(unitName));
    td.style.backgroundColor = "rgb(60,60,60)";
    tr = document.createElement('tr');
    tr.appendChild(td);
    tableNode.appendChild(tr);

    var value, index, index_floor, index_fraction, r, g, b;
    var steps = 20;
    if(this.canvas_height / this.devicePixelRatio >= 650 && this.type_string != 'wind') {
        steps = 30;
    }
    var deltaValue = (maxValue - minValue) / steps;
    for (i = 0; i <= steps; i++) {
        // value as in m/s or °C
        value = deltaValue * (reverse?steps-i:i) + minValue;
        // index position of value for color table
        index = (value - scaleStart) / (scaleEnd - scaleStart) * (colorTable.length / 4 - 1);
        index_floor = Math.floor(index);
        index_fraction = index - index_floor;
        // color interpolation
        r = (1 - index_fraction) * colorTable[index_floor * 4] + (index_fraction > 0 ? index_fraction * colorTable[(index_floor + 1) * 4] : 0);
        g = (1 - index_fraction) * colorTable[index_floor * 4 + 1] + (index_fraction > 0 ? index_fraction * colorTable[(index_floor + 1) * 4 + 1] : 0);
        b = (1 - index_fraction) * colorTable[index_floor * 4 + 2] + (index_fraction > 0 ? index_fraction * colorTable[(index_floor + 1) * 4 + 2] : 0);

        // TODO additional unit conversion
        if(this.type_string == 'wind') {
            value *= sqrt2 * 3.6;
        }
        td = document.createElement('td');
        td.appendChild(document.createTextNode(Math.round(value).toFixed(0)));
        td.style.backgroundColor = "rgb(" + Math.round(r) + "," + Math.round(g) + "," + Math.round(b) + ")";

        tr = document.createElement('tr');
        tr.appendChild(td);
        tableNode.appendChild(tr);
    }
};
/**
 * Control URL Hash
 */
DrawControl.prototype.eventLocationHashChange = function() {
    var hash = window.location.hash.substr(1).split('_');
    var length = hash.length;
    if (length >= 1) {
        var coords = hash[0].split('N');
        if (coords.length == 2) {
            var lat = parseFloat(coords[0]);
            var lon = parseFloat(coords[1]);
            if(!isNaN(lat) && (!isNaN(lon))) {
                this.translation = [
                    this.canvas_width / 2.0 - this.lon2posx(lon),
                    this.canvas_height / 2.0 - this.lat2posy(lat)
                ];
                this.changed_translation = true;
            }
        }
    }
    if(length >= 2) {
        this.setTimezone(hash[1]);
    }
    if(length >= 3) {
        var newScale = parseFloat(hash[2]);
        if(!isNaN(newScale)) {
            this.scale = Math.max(this.scale_min, Math.min(newScale * this.devicePixelRatio, this.scale_max));
            this.changed_scale = true;
        }
    }
    if(length >= 5) {
        this.setNewLevelType(hash[4] == 'surface' ? 0 : parseInt(hash[4]), hash[3], true);
    }
    if (hash.length >= 8) {
        this.animation_running = hash[5] == 'autostart';
        this.playPauseNode.children[0].className = this.animation_running ? 'glyph pause' : 'glyph play';

        var new_animation_start = parseInt(hash[6]) * 1000;
        var timestamp = parseInt(hash[7]) * 1000;
        if(!isNaN(new_animation_start) && !isNaN(timestamp) && new_animation_start > 10000 && timestamp > 10000) {
            if (new_animation_start !== this.animation_start) {
                this.animation_start = Math.max(new_animation_start, this.data_start);
                this.animation_end = Math.min(this.animation_start + 3600000 * (24 * 6 - 1), this.data_end);
                this.timeSlider.generateStartStop(this.animation_start, this.animation_end);

                timestamp = Math.max(this.animation_start, Math.min(timestamp, this.animation_end));
            }

            if (this.dt1.primary_timestamp !== timestamp) {
                this.setTimeStep(timestamp);
            }
        }
    }
    //console.log(hash);
};
/**
 * Set URL location hash with current settings
 * e.g. #47.027_10.195_2.1_temperature_surface_pause_1440115200_1440630000_1440219600
 */
DrawControl.prototype.updateLocationHash = function() {
    history.replaceState(undefined, '', this.getLocationHash());
    this.updateShareLinks();
};
/**
 * Generate URL location hash
 *
 * @returns {string}
 */
DrawControl.prototype.getLocationHash = function (){
    var lon = this.posx2lon(-this.translation[0] + this.canvas_width / 2);
    var lat = this.posy2lat(-this.translation[1] + this.canvas_height / 2);
    var levelName = this.level ? this.level + 'mb' : 'surface';
    var hash = [
        lat.toFixed(3) + 'N' + lon.toFixed(3)+'E',
        this.timezone,
        (this.scale/this.devicePixelRatio).toFixed(1),
        this.type_string,
        levelName,
        this.animation_running ? 'autostart' : 'pause',
        this.animation_start / 1000,
        //this.animation_end / 1000,
        this.dt1.primary_timestamp / 1000
    ];

    return '#' + hash.join('_');
};

/**
 * Generate URL's for sharing buttons
 */
DrawControl.prototype.updateShareLinks = function () {
    var socialShare = document.getElementsByClassName('social-share');
    for (var i in socialShare) {
        if (socialShare.hasOwnProperty(i) && 'object' == typeof socialShare[i]) {
            var s = socialShare[i];
            if ('href' in s) s.href = s.dataset.base + encodeURIComponent(window.location.href);
            if ('value' in s) s.value = window.location.href;
        }
    }

    var websiteShare = document.getElementsByClassName('website-share');
    for (var i in websiteShare) {
        if (websiteShare.hasOwnProperty(i) && 'object' == typeof websiteShare[i]) {
            var w = websiteShare[i];
            w.value = '<iframe src="' + window.location.href + '" width="800" height="600" frameborder="0"></iframe><a href="https://www.meteoblue.com/" target="_blank" title="meteoblue - weather close to you">meteoblue</a>';
        }
    }
};
/**
 * Callback from timeslider
 *
 * @param timestamp
 */
DrawControl.prototype.eventCallbackTimeSlider = function(timestamp) {
    this.setTimestampAndReloadDomains(timestamp + this.utc_offset);
};
/**
 * Start seamless zoom to given scale and transltion vector
 * 
 * @param toScale
 * @param toTranslation
 */
DrawControl.prototype.seamlessZoom = function (toScale, toTranslation) {
    toScale = Math.max(this.scale_min, Math.min(toScale, this.scale_max));
    this.adjustBoundaries(toTranslation, this.calculateLimits(toScale));

    this.seamless_itr = 20;
    this.logScale = Math.log(this.scale) / Math.log(2);
    this.deltaScale = (Math.log(toScale) / Math.log(2) - this.logScale) / this.seamless_itr;
    this.deltaTranslation = [
        (toTranslation[0] - this.translation[0]) / this.seamless_itr,
        (toTranslation[1] - this.translation[1]) / this.seamless_itr
    ];
};
/**
 * Set timestap in models and prepare next draw
 * @param timestamp
 */
DrawControl.prototype.setTimestampAndReloadDomains = function(timestamp) {
    this.animation_running = false;
    this.playPauseNode.children[0].className = this.animation_running ? 'glyph pause' : 'glyph play';

    this.setTimeStep(timestamp);
    this.updateVisibleDomainList(); // new time-step might be outside domain time-frame
    this.prepareDrawAll(); // start domain loading NOW
};
/**
 * @param e {MouseEvent}
 */
DrawControl.prototype.eventClickDayForward = function(e) {
    e.preventDefault();
    if (this.animation_end + this.utc_offset > this.data_end) {
        return;
    }
    var timestamp = this.dt1.primary_timestamp + 3600000 * 24;
    if(timestamp > this.animation_end) {
        this.animation_start = this.animation_start + 3600000 * 24;
        this.animation_end = this.animation_end + 3600000 * 24;
        this.timeSlider.generateStartStop(this.animation_start, this.animation_end);
    }
    this.setTimestampAndReloadDomains(timestamp);
};
/**
 * @param e {MouseEvent}
 */
DrawControl.prototype.eventClickDayBackward = function(e) {
    e.preventDefault();
    if (this.animation_start + this.utc_offset < this.data_start) {
        return;
    }
    var timestamp = this.dt1.primary_timestamp - 3600000 * 24;
    if(timestamp < this.animation_start) {
        this.animation_start = this.animation_start - 3600000 * 24;
        this.animation_end = this.animation_end - 3600000 * 24;
        this.timeSlider.generateStartStop(this.animation_start, this.animation_end);
    }
    this.setTimestampAndReloadDomains(timestamp);
};
/**
 * Open / close menu
 *
 * @param e {MouseEvent}
 */
DrawControl.prototype.eventClickMenuToggle = function(e) {
    e.preventDefault();
    this.menuNodeOpen = !this.menuNodeOpen;
    if(this.menuNodeOpen) {
        this.menuNode.classList.remove('hide');
    } else {
        this.menuNode.classList.add('hide');
    }
    // close sharer menu
    if(this.sharerNodeOpen) {
        this.shareNode.classList.add('hide');
        this.sharerNodeOpen = false;
    }
};
/**
 * Open / close share options
 *
 * @param e {MouseEvent}
 */
DrawControl.prototype.eventClickShareToggle = function(e) {
    e.preventDefault();
    this.sharerNodeOpen = !this.sharerNodeOpen;
    if(this.sharerNodeOpen) {
        this.shareNode.classList.remove('hide');
    } else {
        this.shareNode.classList.add('hide');
    }
    // close menu
    if(this.menuNodeOpen) {
        this.menuNode.classList.add('hide');
        this.menuNodeOpen = false;
    }
};
/**
 * @param e {MouseEvent}
 */
DrawControl.prototype.eventClickHourForward = function(e) {
    e.preventDefault();
    this.setTimestampAndReloadDomains(this.dt1.primary_timestamp + 3600000);
};
/**
 * @param e {MouseEvent}
 */
DrawControl.prototype.eventClickHourBackward = function(e) {
    e.preventDefault();
    this.setTimestampAndReloadDomains(this.dt1.primary_timestamp - 3600000);
};
/**
 * @param e {MouseEvent}
 */
DrawControl.prototype.eventClickNowTime = function(e) {
    e.preventDefault();
    this.initTimestamps(); // update timestamps
    this.initAnimationTimeframe(); // today to 6-days
    this.timeSlider.generateStartStop(this.animation_start, this.animation_end);
    this.setTimestampAndReloadDomains(this.timestamp_now);
};
/**
 * Set animation frame to today to six days, starting at current time
 */
DrawControl.prototype.initAnimationTimeframe = function() {
    this.animation_start = this.timestamp_today;
    this.animation_end = Math.min(this.timestamp_today + 3600000 * (24 * 6 - 1), this.data_end); // day 6 at 23:00 UTC
};

/**
 *
 * @param e {MouseEvent}
 */
DrawControl.prototype.eventClickFullscreen = function(e) {
    window.top.location.href = this.getLocationHash();
};

/**
 * Format timestamp used in file format
 *
 * @param timestamp_ms {number}
 */
DrawControl.prototype.toDateString = function(timestamp_ms) {
    if (!timestamp_ms) {
        return false;
    }
    var d = new Date(timestamp_ms);
    var month = d.getUTCMonth() + 1; // month is defined 0-11
    if (month < 10) {
        month = '0' + month;
    }
    var day = d.getUTCDate();
    if (day < 10) {
        day = '0' + day;
    }
    var hours = d.getUTCHours();
    if (hours < 10) {
        hours = '0' + hours;
    }
    var file = this.level ? this.level + 'mbdata_' : 'data_';
    return d.getUTCFullYear() + '' + month + day + '/' + file + hours + '00';
};

/**
 * Updates dt1 or dt3 structure with new timestep
 *
 * @param dt
 * @param delta_hour
 * @param primary
 */
DrawControl.prototype.setPrimary = function(dt, delta_hour, primary) {
    var mod = (primary / 36000) % delta_hour;
    dt.fraction = mod / 3;
    primary -= 1000 * 60 * 60 * mod;


    if (dt.primary_timestamp === primary) {
        return; // timestep already loaded
    }
    this.prepareDomainDraw = true;

    dt.primary_timestamp = primary;
    dt.primary = primary === dt.second_timestamp ? dt.second : this.toDateString(primary);

    var next;
    dt.second_timestamp = primary + 1000 * 60 * 60 * delta_hour;
    if (dt.second_timestamp > this.animation_end + this.utc_offset || dt.second_timestamp > this.data_end) { // next image is not available
        next = Math.max(this.animation_start + this.utc_offset, this.data_start);
        dt.second_timestamp = next - 1000 * 60 * 60 * ((next / 36000) % delta_hour);
    }
    dt.second = dt.second_timestamp === dt.preload_timestamp ? dt.preload : this.toDateString(dt.second_timestamp);

    dt.preload_timestamp = dt.second_timestamp + 1000 * 60 * 60 * delta_hour;
    if (dt.preload_timestamp > this.animation_end + this.utc_offset || dt.preload_timestamp > this.data_end) { // preload not possible
        next = Math.max(this.animation_start + this.utc_offset, this.data_start);
        dt.preload_timestamp = next - 1000 * 60 * 60 * ((next / 36000) % delta_hour);
    }
    dt.preload = this.toDateString(dt.preload_timestamp);
};
/**
 * Draw frame. Called via requestAnimationFrame
 * Performs all kinds of event dispatching
 */
DrawControl.prototype.drawFrame = function() {
    if (this.anmiationFrameId === null) {
        return;
    }

    //var start = performance.now();
    var i, prog;
    var gl = this.gl;

    /**
     * Check if window got a new size and dispatch event
     */
    if (this.resize_in_n_frames && --this.resize_in_n_frames == 0) {
        this.handleCanvasResize();
    }
    /**
     * Zoom in/out occurred
     */
    if (this.changed_scale) {
        this.updateVelocityAdjustment();
        gl.uniform1f(this.u_scale, this.scale); // upload to gpu
        this.limits_offset = this.calculateLimits(this.scale);
        this.svg_transform_update = true;
        this.update_domains_in_n_frames = this.update_domains_in_n_frames || 60;
        this.update_svg_in_n_frames = this.update_svg_in_n_frames || 60;
        this.changed_translation = true; // force boundary update
        this.changed_scale = false;
    }
    /**
     * Move occurred
     */
    if (this.changed_translation) {
        this.adjustBoundaries(this.translation, this.limits_offset);
        gl.uniform2fv(this.u_translation, this.translation); // upload to gpu
        this.svg_transform_update = true;
        this.update_domains_in_n_frames = this.update_domains_in_n_frames || 60;
        this.update_svg_in_n_frames = this.update_svg_in_n_frames || 60;
        this.changed_translation = false;
    }
    /**
     * Seamless zoom to given location is requested
     */
    if (this.seamless_itr) {
        this.translation[0] += this.deltaTranslation[0];
        this.translation[1] += this.deltaTranslation[1];
        this.logScale += this.deltaScale;
        this.scale = Math.pow(2, this.logScale);
        gl.uniform1f(this.u_scale, this.scale); // upload to gpu
        gl.uniform2fv(this.u_translation, this.translation); // upload to gpu
        this.updateVelocityAdjustment();
        this.svg_transform_update = true;
        if (!--this.seamless_itr) {
            this.update_domains_in_n_frames = this.update_domains_in_n_frames || 60;
            this.update_svg_in_n_frames = this.update_svg_in_n_frames || 60;
            this.limits_offset = this.calculateLimits(this.scale);
            this.adjustBoundaries(this.translation, this.limits_offset);
        }
    }
    /**
     * Search for visible domains and update lists
     */
    if (this.update_domains_in_n_frames && --this.update_domains_in_n_frames == 0) {
        this.updateVisibleDomainList();
    }
    /**
     * Process all domains and check if they are drawable or need to load images
     * State variables like 'drawable' or 'preloaded' are updated
     */
    if (this.prepareDomainDraw) { // something loaded or animation was started
        this.prepareDrawAll();
    }
    /**
     * Show loading message. This is delayed to prevent 'on' / 'off' toggles
     */
    if (this.showLoadingMessageInFrames && --this.showLoadingMessageInFrames == 0) {
        this.showLoadingMessageNode.classList.add('loading');
        this.showLoadingMessageActive = true;
    }
    /**
     * At least one domain has no data or wont be able to draw the next time-step
     * Recalculate domainlist on next frame
     */
    if (this.endOfDomain) {
        console.warn('one domain is out of time-frame... recalculating on next iteration');
        this.update_domains_in_n_frames = 1;
    }
    /**
     * Animation is running and we keep increasing dt1+dt3 fractions until 1. Then process to next image
     * In case of animation end: setTimeStep will set animation start images for preloading
     */
    if (this.animation_running) {
        if (this.dt1.fraction < 1) {
            if (this.deltaReady) {
                this.dt1.fraction += this.nonSteadySpeed;
                this.dt3.fraction += this.nonSteadySpeed / 3;
                //console.log('draw fraction image from'+this.dt1.primary+' to '+this.dt1.second);
            }
        } else {
            // transitioned to second image complete.. dt is now 1 or slightly greater
            if (this.preloaded && !this.visibleDomainsNext) {
                // all domains are pre-loaded and we are safe to switch to the next state
                this.setTimeStep(this.dt1.primary_timestamp + 3600000);
            }
        }
    }

    /**
     * At least one domain seams to be drawable
     */
    if (this.drawable) {
        var count_drawn = 0;
        /**
         * Try to draw domain. It is still possible a domain is not able to draw and returns false (0)
         */
        for (i = 0; i < this.visibleDomains.length; ++i) {
            prog = this.visibleDomains[i];
            count_drawn += prog.draw(gl, this.flowProgram.input_buffer, prog.dt === 3 ? this.dt3 : this.dt1, this.u_blendimages);
        }
        /**
         * At least one domain was drawn into buffer. Update flow layer
         */
        if (count_drawn > 0) {
            // draw flow layer
            var newSeamless = null;
            /**
             * Seamless switch between wind temp mask toggle
             */
            if (this.type_seamless < this.type_mask) {
                this.type_seamless += 0.03;
                if (this.type_seamless > this.type_mask) {
                    this.type_seamless = this.type_mask;
                }
                newSeamless = this.type_seamless;
            }
            if (this.type_seamless > this.type_mask) {
                this.type_seamless -= 0.03;
                if (this.type_seamless < this.type_mask) {
                    this.type_seamless = this.type_mask;
                }
                newSeamless = this.type_seamless;
            }

            this.flowProgram.draw(gl, newSeamless);
            gl.useProgram(this.domain_program); // switch back

            /**
             * Redraw svg country shape with locations
             */
            if (this.update_svg_in_n_frames && --this.update_svg_in_n_frames === 0) {
                // update SVG background
                this.drawSVG();
                this.updateLocationHash();
            }
            /**
             * Move or scale via CSS transformation the canvas for country shapes
             * This enables seamless movement, but gets blurry and out of view-port
             * drawSVG should be called soon
             */
            if (this.svg_transform_update) {
                var ctx = this.svg_context;
                var canvas = this.svg_canvas;
                var svg_scale = (this.scale / ctx.scale).toFixed(10);
                var svg_translate_x = ((this.translation[0] - ctx.translation[0]) * this.scale / this.devicePixelRatio).toFixed(10);
                var svg_translate_y = ((ctx.translation[1] - this.translation[1]) * this.scale / this.devicePixelRatio).toFixed(10);
                var css_transform = "matrix(" + svg_scale + ",0,0," + svg_scale + "," + svg_translate_x + "," + svg_translate_y + ")";
                canvas.style.transform = css_transform;
                canvas.style.webkitTransform = css_transform;
                canvas.style.msTransform = css_transform;
                this.svg_transform_update = false;
            }
        }
    }

    this.anmiationFrameId = requestAnimationFrame(this.tickBind);
};

/**
 * Called from High and Low res SVG image load.
 *
 * Draw with next animation frame
 *
 * @param e {Event}
 */
DrawControl.prototype.svgOnLoad = function(e) {
    e.target.loaded = true;
    this.update_svg_in_n_frames = 1;
};

/**
 * Look for domains in view-port and time-step
 * This function is called once the view-port is changed or a domain reached its end
 *
 * Updates this.visibleDomainsNext with the next domain set
 *
 * forceNextTimeStep is used at the end of a domain to force loading the next time-step
 */
DrawControl.prototype.updateVisibleDomainList = function() {
    var newDomains = [];
    var domain, i, visible, hasTimeFrame, classList;

    // domain must be at least 33% in viewport to be displayed
    var x_ignore = this.canvas_width / (3 * (this.scale + 1));
    var y_ignore = this.canvas_height / (3 * (this.scale + 1));

    var length = this.allDomains.length;
    for (i = 0; i < length; ++i) {
        domain = this.allDomains[i];
        classList = domain.span.classList;
        visible = domain.isVisible(this.limits_offset, x_ignore, y_ignore, this.scale / this.devicePixelRatio, this.level, this.translation);
        hasTimeFrame = domain.hasTimeFrame(domain.dt === 3 ? this.dt3 : this.dt1, this.endOfDomain);
        if(visible && hasTimeFrame) {
            classList.remove('hide');
        } else {
            classList.add('hide');
        }
        /*if (visible && !hasTimeFrame) {
            classList.add('out_of_timeframe');
        } else {
            classList.remove('out_of_timeframe');
        }*/

        if (hasTimeFrame && visible) {
            if (visible === 2) {
                // fullscreen
                newDomains.forEach(function(e){
                    e.span.classList.add('hide');
                });
                newDomains = [domain];
            } else {
                // partly visible
                newDomains.push(domain);
            }
        }
    }

    if (newDomains.equals(this.visibleDomains)) {
        //console.log('new domains equals to current list');
        this.visibleDomainsNext = false;
        return;
    }
    if (newDomains.equals(this.visibleDomainsNext)) {
        //console.log('new domains equals to next list');
        return;
    }

    //console.log('Preparing new domain list');
    this.prepareDomainDraw = true;
    this.visibleDomainsNext = newDomains;
};

/**
 * Set new timestep for dt1+3, update timeline and url location hash
 * @param time {Number}
 */
DrawControl.prototype.setTimeStep = function(time) {
    var offset = this.utc_offset;
    if (time > this.animation_end + offset || time > this.data_end) {
        //console.log('animation end reached in setTimeStep');
        if (this.animation_running) {
            // restart animation
            time = this.animation_start + offset;
            this.update_domains_in_n_frames = 1; // trigger recalculation
        } else {
            time = time > this.data_end ? this.data_end : (this.animation_end + offset);
        }

    }
    if (time < this.data_start) {
        time = this.data_start;
    }
    if (time < this.animation_start + offset) {
        time = this.animation_start + offset;
    }

    this.setPrimary(this.dt1, 1, time);
    this.setPrimary(this.dt3, 3, time);
    //console.log('next time-step enabled: ',this.dt1.primary, this.dt1.second);
    //this.setActiveDatetime(this.dt1.primary_timestamp);
    this.updateLocationHash(); // timestep in url

    this.timeSlider.setTime(time - this.utc_offset);
};
/**
 * Check all visible and visibleNext domains and load images
 *
 * If visibleNext is ready, move it into visible domain list
 */
DrawControl.prototype.prepareDrawAll = function() {
    var prog, i, length;
    //console.log('preparing domains draws');

    this.showLoadingMessage = false;
    if (this.visibleDomainsNext) {
        // a new domain list is pending to load
        //onsole.log('prepare new domain set', this.visibleDomainsNext);

        this.drawable = true;
        length = this.visibleDomainsNext.length;
        for (i = 0; i < length; ++i) {
            prog = this.visibleDomainsNext[i];
            prog.prepareDraw(prog.dt === 3 ? this.dt3 : this.dt1, this);
        }

        // new domain set is drawable -> swap buffers
        if (this.drawable || this.visibleDomains.length === 0) {
            //console.log('enable new domain set', this.visibleDomainsNext);
            this.endOfDomain = false;
            this.visibleDomains = this.visibleDomainsNext; // new domain set is ready
            this.visibleDomainsNext = false;
        }
    }

    this.deltaReady = true; // reset counter
    this.drawable = true;
    this.preloaded = true;
    length = this.visibleDomains.length;
    for (i = 0; i < length; ++i) {
        prog = this.visibleDomains[i];
        prog.prepareDraw(prog.dt === 3 ? this.dt3 : this.dt1, this);
    }

    // Show or hide loading message
    this.setLoading(this.showLoadingMessage);

    this.prepareDomainDraw = false;
};
/**
 * Show or hide loading animation
 * @param show {Boolean}
 */
DrawControl.prototype.setLoading = function(show) {
    if(!show) {
        this.showLoadingMessageInFrames = 0;
    }
    if(show && !this.showLoadingMessageActive) {
        this.showLoadingMessageInFrames = 20;
    }
    if(!show && this.showLoadingMessageActive) {
        this.showLoadingMessageNode.classList.remove('loading');
        this.showLoadingMessageActive = false;
    }
};
/**
 * browser was resized:
 * - set new canvas sizes
 * - synchronized buffer replacement
 * - update all boundaries and domains
 */
DrawControl.prototype.handleCanvasResize = function() {
    var gl = this.gl;

    // resize canvas elements and set canvas_width and canvas_height
    this.setCanvasSizes();

    this.flowProgram.initBuffers(gl, this.canvas_width, this.canvas_height);

    var prog = this.domain_program;
    gl.useProgram(prog);
    gl.uniform2f(gl.getUniformLocation(prog, "u_canvasSize"), this.canvas_width, this.canvas_height);
    gl.uniform2f(gl.getUniformLocation(prog, "u_resolution"), this.canvas_width, this.canvas_height);

    this.update_domains_in_n_frames = 1;
    this.update_svg_in_n_frames = 1;
    this.seamless_itr = 0;
    this.changed_translation = true;
    this.changed_scale = true;
};
/**
 * Start animation. Get a binding function for this.tick and request animation frame
 */
DrawControl.prototype.start = function () {
    this.anmiationFrameId = requestAnimationFrame(this.tickBind);
};
/**
 * Update velocity of flow animation: u_h parameter
 */
DrawControl.prototype.updateVelocityAdjustment = function() {
    /** Velocity adjustment only on changed this.scale **/
    var h = (1.0 + (Math.pow(this.scale, 0.4))) * this.devicePixelRatio;
    this.gl.uniform1f(this.u_h, h); // upload to gpu
    /** END Velocity adjustment **/
};
/**
 * Draw SVG country shape, locations and position marker on canvas
 * Reset canvas css transformation
 *
 * This function is quite expensive and should not be called to often
 */
DrawControl.prototype.drawSVG = function() {
    var scale = this.scale;
    var devicePixelRatio = this.devicePixelRatio;
    var scalePixelRatio = scale / devicePixelRatio;
    var svg = scalePixelRatio >= 2.5 ? this.svg_image_high : this.svg_image_low;
    if (!svg.loaded) {
        return;
    }
    var ctx = this.svg_context;
    // reset css transform
    ctx.save();
    //var start = performance.now();
    var css_transform = "matrix(1,0,0,1,0,0)";
    var svg_canvas = this.svg_canvas;
    svg_canvas.style.transform = css_transform;
    svg_canvas.style.webkitTransform = css_transform;
    svg_canvas.style.msTransform = css_transform;
    ctx.transform_update = false;

    var width = this.canvas_width;
    var height = this.canvas_height;
    var city, pos_x, pos_y;
    var translation_x = this.translation[0];
    var translation_y = this.translation[1];

    // clear canvas
    ctx.clearRect(0, 0, width, height);
    var y_trans = (-translation_y - this.global_height) * scale + ((scale + 1) * height) / 2;
    var x_trans = translation_x * scale - ((scale - 1) * width) / 2;
    ctx.translation[0] = translation_x;
    ctx.translation[1] = translation_y;
    ctx.scale = scale;
    ctx.drawImage(svg, x_trans, y_trans, this.global_width * scale , this.global_height * scale );
    //console.log(Math.round((performance.now() - start)) + "ms printing svg shape on canvas");

    //start = performance.now();
    var ref_x = translation_x * scale - ((scale - 1) * width) / 2;
    var ref_y = -translation_y * scale + ((scale + 1) * height) / 2;
    var fontSizeBase = Math.max(0, scale / devicePixelRatio - 30) / 30 * devicePixelRatio;
    var fontSize;
    if (scalePixelRatio >= 2.5) {
        var centered = false;// scale > 50;
        ctx.beginPath();
        ctx.shadowColor = "#ffffff";
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
        ctx.shadowBlur = 3 * devicePixelRatio;
        ctx.lineWidth = 4 * devicePixelRatio;
        ctx.strokeStyle = "#333333";
        ctx.font = "bold " + (13*devicePixelRatio + fontSizeBase)  + "px Arial";
        ctx.textAlign = centered ? 'center' : 'left';
        ctx.fillStyle = "#333333";

        var capitals = this.capitals;
        var capitals_len = capitals.length;

        for(var i = 0; i < capitals_len; ++i) {
            city = capitals[i];
            if (city.scale > scalePixelRatio) {
                continue;
            }
            pos_x = ref_x + city.x * scale;
            pos_y = ref_y - city.y * scale;
            if (pos_x < 0 || pos_x > width || pos_y < 0 || pos_y > height) {
                continue; // city not in viewport
            }
            fontSize = fontSizeBase;
            if(city.scale === 0) {
                fontSize *= 7;
            }
            if(city.scale === 9) {
                fontSize *= 6;
            }
            if(city.scale === 15) {
                fontSize *= 5;
            }
            if(city.scale === 30) {
                fontSize *= 2;
            }
            ctx.font = "bold " + (13*devicePixelRatio + fontSize) + "px Arial";
            if (centered) {
                ctx.fillText(city.name, pos_x, pos_y);
            } else {
                ctx.moveTo(pos_x - 2 * devicePixelRatio, pos_y);
                ctx.lineTo(pos_x + 2 * devicePixelRatio, pos_y);
                ctx.fillText(city.name, pos_x + 3 * devicePixelRatio, pos_y - 3 * devicePixelRatio);
            }
        }
        ctx.stroke();
    }

    // highlight geoip/lastvisited position
    var crossLength =  6 * devicePixelRatio;
    marker = this.geoMarkerXY;
    if (marker) {
        pos_x = ref_x + marker[0] * scale;
        pos_y = ref_y - marker[1] * scale;
        ctx.beginPath();
        ctx.shadowColor = "#ffffff";
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
        ctx.shadowBlur = 3 * devicePixelRatio;
        ctx.lineWidth = 2 * devicePixelRatio;
        ctx.strokeStyle = "#0000ff";
        /*if (scale > 2.5) {
            fontSize = fontSizeBase * 7;
            ctx.font = "bold " + (14 + fontSize) * devicePixelRatio + "px Arial";
            ctx.fillStyle = "#0000ff";
            ctx.fillText(marker[2], pos_x + 2 * devicePixelRatio, pos_y - 2 * devicePixelRatio);
        }*/
        ctx.moveTo(pos_x - crossLength, pos_y);
        ctx.lineTo(pos_x + crossLength, pos_y);
        ctx.moveTo(pos_x, pos_y - crossLength);
        ctx.lineTo(pos_x, pos_y + crossLength);
        ctx.stroke();
    }

    // highlight selected position
    var marker = this.positionMarkerXY;
    if (marker) {
        pos_x = ref_x + marker[0] * scale;
        pos_y = ref_y - marker[1] * scale;
        ctx.beginPath();
        ctx.shadowColor = "#ffffff";
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
        ctx.shadowBlur = 3 * devicePixelRatio;
        ctx.lineWidth = 2 * devicePixelRatio;
        ctx.strokeStyle = "#ff0000";
        ctx.moveTo(pos_x - crossLength, pos_y);
        ctx.lineTo(pos_x + crossLength, pos_y);
        ctx.moveTo(pos_x, pos_y - crossLength);
        ctx.lineTo(pos_x, pos_y + crossLength);
        ctx.stroke();
    }

    /*ctx.beginPath();
     ctx.shadowColor = "#ffffff";
     ctx.shadowOffsetX = 0;
     ctx.shadowOffsetY = 0;
     ctx.shadowBlur = 3;
     ctx.lineWidth = 4;
     ctx.strokeStyle = "#ff0000";
     ctx.lineWidth = 2 * devicePixelRatio;

     var reference_points = [
     53.557211, -168.084763,
     53.482785, -167.806528,
     53.276705, -168.119783,
     53.256827, -168.348513,
     53.228573, -168.296532,
     53.202102, -168.714542,
     53.087446, -168.447732,
     53.020686, -168.819119,
     52.902051, -168.876093,
     52.933014, -168.955495,
     52.865715, -168.956474,
     52.799461, -169.162301,
     52.766687, -169.244126,
     53.521236, -167.793536,
     53.504220, -168.258416,
     53.263580, -168.175069,
     53.392866, -168.392862,
     53.364166, -167.892269,
     53.436775, -167.858903,
     53.505818, -167.786933,
     53.522210, -167.908318,
     53.261110, -168.443696,
     53.179099, -168.762348,
     53.115353, -168.804687,
     53.183259, -168.341548,
     53.119160, -168.401372,
     53.012148, -168.608837,
     -46.688141, 167.871989,
     -46.714991, 167.951688,
     -46.774472, 167.995832,
     -46.821245, 168.052318,
     -46.879365, 168.129414,
     -46.977736, 168.181701,
     -47.059775, 168.205051,
     -47.107569, 168.200531,
     -47.125234, 168.046875,
     -47.137707, 167.959731,
     -47.167419, 167.901643,
     -47.191291, 167.810745,
     -47.178088, 167.758632,
     -47.210302, 167.708657,
     -47.243410, 167.661900,
     -47.259610, 167.611567,
     -47.284895, 167.515233,
     -47.204187, 167.495024,
     -47.143811, 167.571605,
     -47.092878, 167.556980,
     -47.062528, 167.598959,
     -47.020208, 167.696550,
     -46.971498, 167.671921,
     -46.961690, 167.722739,
     -46.942097, 167.754262,
     -46.895414, 167.765959,
     -46.849567, 167.749134,
     -46.818204, 167.725786,
     -46.797229, 167.704129,
     -46.781295, 167.718459,
     -46.754175, 167.706154,
     -46.734580, 167.725000,
     -46.711508, 167.737856,
     -46.697371, 167.765075,
     -46.693647, 167.807576,
     -46.905531, 168.121805,
     -46.907219, 168.089910,
     -46.913414, 168.050212,
     -46.929733, 168.014328,
     -46.946748, 168.050125,
     -46.955196, 168.086240,
     -46.956829, 168.121828,
     -52.477814, 169.164249,
     -52.603399, 169.151013,
     -52.535780, 169.235498,
     -52.543757, 169.019818,
     -52.501295, 169.220852,
     -52.525047, 169.132368,
     -52.593406, 169.216261,
     -52.587438, 169.119448,
     -52.571554, 169.085205,
     -52.564811, 169.048192,
     -54.804144, -35.903723,
     -54.006716, -38.066043,
     -54.417723, -36.819404,
     -54.088334, -36.890840,
     -54.349874, -36.225827,
     70.798008, 160.632575,
     70.911877, 160.446315,
     70.909492, 160.514944,
     70.891375, 160.593104,
     70.877850, 160.658623,
     70.836821, 160.693686,
     70.819650, 160.746428,
     70.802258, 160.754414,
     70.800252, 160.694105,
     70.804057, 160.528726,
     70.824077, 160.514397,
     70.845038, 160.545581,
     70.883574, 160.552896,
     70.890411, 160.521439,
     70.895206, 160.471299,
     69.646318, -141.0,
     69.546318, -141.0,
     69.446318, -141.0,
     69.346318, -141.0,
     69.246318, -141.0,
     69.146318, -141.0,
     69.046318, -141.0,
     68.946318, -141.0,
     60.306368, -141.0,
     49.0, -123.322198,
     49.0, -123.222198,
     49.0, -123.122198,
     49.0, -123.022198,
     49.0, -122.922198,
     49.0, -122.822198,
     49.0, -122.722198,
     49.0, -122.622198,
     49.0, -122.522198,
     49.0, -122.422198,
     ];

     for(var i = 0; i < reference_points.length; i+=2) {
     var pos_y = ref_y - scale * lat2posy(reference_points[i]);
     var pos_x = scale * lon2posx(reference_points[i+1]) + ref_x;
     ctx.moveTo(pos_x - 2, pos_y);
     ctx.lineTo(pos_x + 2, pos_y);
     }


     ctx.stroke();*/

    //console.log(Math.round((performance.now() - start)) + "ms printing capitals on canvas");
    ctx.restore();
};
/**
 * Scale and translate viewport to show the complete domain
 *
 * @param domain {DomainProgram}
 */
DrawControl.prototype.callbackCenterDomain = function(domain) {
    this.scale = Math.max(this.canvas_width / (domain.x2 - domain.x1), this.canvas_height / (domain.y2 - domain.y1));
    this.translation[0] = this.canvas_width / 2.0 - (domain.x1 + domain.x2) / 2;
    this.translation[1] = this.canvas_height / 2.0 - (domain.y1 + domain.y2) / 2;
    this.changed_translation = true;
    this.changed_scale = true;
    this.update_domains_in_n_frames = 1;
};
/**
 * Create domain programs and vertex buffers
 * Flow program must be initialised before
 *
 * @param domainInits Array with JSON structures from static server
 */
DrawControl.prototype.initDomains = function(domainInits) {
    // create webgl domain program and setup uniforms
    var fragment_shader_c2 = "\
        precision highp float;\n\
        \n\
        uniform float u_h;\n\
        uniform float u_blendimages;\n\
        \n\
        // our texture\n\
        uniform sampler2D u_image;\n\
        uniform sampler2D u_image2;\n\
        uniform sampler2D u_coordinates;\n\
        uniform vec2 u_canvasSize;\n\
        \n\
        // the texCoords passed in from the vertex shader.\n\
        varying vec2 v_texCoord;\n\
        \n\
        void main() {\n\
            // coordinates from previous iteration\n\
            vec2 c2 = texture2D(u_coordinates, gl_FragCoord.xy / u_canvasSize).rg;\n\
            \n\
            // field at given coordinates\n\
            vec4 velocity_field = mix(texture2D(u_image, v_texCoord), texture2D(u_image2, v_texCoord), u_blendimages);\n\
            \n\
            //eulerian step\n\
            c2 = fract(c2) - u_h*(velocity_field.rg - 0.5);\n\
            \n\
            gl_FragColor = vec4(c2, length(velocity_field.rg - 0.5)*2.0, velocity_field.b);\n\
        }";


    var vertex_shader_domain = "\
        precision highp float;\n\
        \n\
        attribute vec2 a_position;\n\
        attribute vec2 a_texCoord;\n\
        \n\
        uniform vec2 u_resolution;\n\
        uniform float u_scale;\n\
        uniform vec2 u_translation;\n\
        \n\
        varying vec2 v_texCoord;\n\
        \n\
        void main() {\n\
            gl_Position = vec4((((a_position + u_translation) / u_resolution) * 2.0 - 1.0) * u_scale, 0, 1);\n\
            v_texCoord = a_texCoord;\n\
        }";

    var gl = this.gl;
    var global_width = this.global_width;
    var global_height = this.global_height;
    var canvas_width = this.canvas_width;
    var canvas_height = this.canvas_height;

    this.domain_program = createProgram(gl, [
        createShaderFromScript(gl, vertex_shader_domain, gl.VERTEX_SHADER),
        createShaderFromScript(gl, fragment_shader_c2, gl.FRAGMENT_SHADER)
    ]);
    var prog = this.domain_program;
    gl.useProgram(prog);
    gl.uniform2f(gl.getUniformLocation(prog, "u_canvasSize"), canvas_width, canvas_height);
    gl.uniform2f(gl.getUniformLocation(prog, "u_resolution"), canvas_width, canvas_height);
    gl.uniform1i(gl.getUniformLocation(prog, "u_coordinates"), 1);
    gl.uniform1i(gl.getUniformLocation(prog, "u_image"), 4);
    gl.uniform1i(gl.getUniformLocation(prog, "u_image2"), 5);
    this.u_h = gl.getUniformLocation(prog, "u_h");
    this.u_scale = gl.getUniformLocation(prog, "u_scale");
    this.u_translation = gl.getUniformLocation(prog, "u_translation");
    this.u_blendimages = gl.getUniformLocation(prog, "u_blendimages");

    var indexArray = [0, 1, 2, 2, 1, 3];
    var vertexArray = [-1, -1, 1, -1, -1, 1, 1, 1];
    var texCoordArray = [0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 1.0, 1.0];

    // local domains are 0.2 degree off
    var x_correction = global_width * 360.2 / 360000;
    var y_correction = global_height * 180.1 / 180000;
    var x1, x2, y1, y2;
    var init;

    // setup domain programs and vertices
    for (var h = 0; h < domainInits.length; ++h) {
        init = domainInits[h];
        if(!init) {
            continue
        }
        init.tlast -= 3600000;
        if (init.position.y[1] == 1000) {
            // global
            x1 = 0;
            x2 = global_width;
            y1 = 0;
            y2 = global_height;
        } else {
            x1 = init.position.x[0] * x_correction;
            x2 = init.position.x[1] * x_correction;
            y1 = init.position.y[0] * y_correction;
            y2 = init.position.y[1] * y_correction;
        }
        var vertex_offset = init.order + 1;
        indexArray.push(vertex_offset * 4, 1 + vertex_offset * 4, 2 + vertex_offset * 4, 2 + vertex_offset * 4, 1 + vertex_offset * 4, 3 + vertex_offset * 4);
        vertexArray.push(x1, y1, x2, y1, x1, y2, x2, y2);
        texCoordArray.push(0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 1.0, 1.0);

        this.allDomains.push(new DomainProgram(gl, init, x1, x2 , y1, y2, vertex_offset, this.callbackNewDomainData.bind(this), this.time_format, this.callbackCenterDomain.bind(this)));

        // look for last possible timestep
        this.data_end = Math.max(this.data_end, init.tlast);
    }
    //console.log("Last possible timestep: ", new Date(this.data_end));

    // Each domain initialization add new coordines to texCoordArray etc
    // Create buffer and enable all tex coordinates, vertex and index buffers
    var texCoordLocation = gl.getAttribLocation(prog, "a_texCoord");
    gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(texCoordArray), gl.STATIC_DRAW);
    gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0);
    gl.enableVertexAttribArray(texCoordLocation);

    var positionLocation = gl.getAttribLocation(prog, "a_position");
    gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertexArray), gl.STATIC_DRAW);
    gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 0, 0);
    gl.enableVertexAttribArray(positionLocation);

    // index buffer for vertices positions
    var bigIndexBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, bigIndexBuffer);
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indexArray), gl.STATIC_DRAW);
};